import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    nav_home: "Home",
    nav_about: "About",
    nav_business: "Business Support",
    nav_programs: "Programs",
    nav_partners: "Partners",
    nav_donate: "Donate",
    nav_reports: "Reports",
    nav_contacts: "Contacts",

    // Home page
    hero_title: "Creating Hope Through Support",
    hero_subtitle: "Charitable Foundation Graweo",
    hero_description: "We create conditions for people who have experienced difficult circumstances to rebuild their lives, work, and dignity",
    hero_cta: "Donate Now",

    about_title: "About Foundation",
    about_description: "Graweo is a charitable foundation dedicated to helping people rebuild after hardship. We focus on providing support for recovery, reintegration, and rebuilding of livelihoods.",

    directions_title: "Directions of Help",
    direction_humanitarian: "Essential Support",
    direction_humanitarian_desc: "Resources, assistance, and necessities for recovery",
    direction_idps: "Reintegration",
    direction_idps_desc: "Community integration, legal support",
    direction_business: "Livelihood Recovery",
    direction_business_desc: "Skills training, business support, employment assistance",

    howwework_title: "How We Work",
    howwework_step1: "Understand Needs",
    howwework_step1_desc: "We analyze situations and assess individual circumstances",
    howwework_step2: "Mobilize Resources",
    howwework_step2_desc: "We attract support and find partners",
    howwework_step3: "Provide Support",
    howwework_step3_desc: "We deliver tailored assistance to those who need it",
    howwework_step4: "Report & Learn",
    howwework_step4_desc: "Full transparency and continuous improvement",

    latest_reports: "Latest Reports",
    view_report: "View Report",
    all_reports: "All Reports",
    video_title: "Graweo in Action",

    // About page
    mission_title: "Our Mission",
    mission_text: "Our mission is to create conditions where people who have experienced difficult circumstances can rebuild their lives, work, and sense of dignity. We operate without borders, helping where support is most needed, and strengthening hope for a sustainable future.",

    goals_title: "Our Goals",
    goal1: "Provide essential support to those in vulnerable situations",
    goal2: "Enable successful reintegration",
    goal3: "Help rebuild livelihoods and economic independence",
    goal4: "Maintain full transparency in all operations",

    legal_title: "Legal Information",
    legal_name: "Name:",
    legal_name_value: "Charitable Foundation GRAWEO",
    legal_registration: "Registration:",
    legal_country: "Country:",
    legal_address: "Address:",
    legal_country_value: "Ukraine",
    legal_address_value: "Kharkiv, Ukraine",

    requisites_title: "Bank Requisites",
    requisites_ukraine: "Ukraine",
    requisites_poland: "Poland",
    requisites_account: "Account:",
    requisites_bank: "Bank:",
    requisites_swift: "SWIFT:",
    requisites_iban: "IBAN:",

    // Donate page
    donate_title: "Support Our Mission",
    donate_subtitle: "Your contribution helps us provide essential aid to those in need",

    crypto_title: "Cryptocurrency Donations",
    crypto_subtitle: "Instant and secure",
    copy_address: "Copy Address",
    address_copied: "Address copied!",

    bank_title: "Bank Transfer",
    card_coming_soon: "Coming soon — bank transfer details will be available shortly.",
    bank_ukraine: "Ukraine (UAH)",
    bank_poland: "Poland (PLN/EUR)",

    card_title: "Card Payment",
    card_button: "Donate via Card",
    card_description: "Fast, secure payment with credit or debit card via Stripe",

    currency_select_title: "Choose Donation Currency",
    currency_select_subtitle: "Select the currency you'd like to donate in",
    currency_donate_button: "Donate",
    currency_stripe_note: "You will be redirected to a secure Stripe payment page",

    purpose_title: "Purpose of Donation",
    purpose_humanitarian: "Essential Support",
    purpose_idps: "Reintegration",
    purpose_business: "Livelihood Recovery",
    purpose_other: "Other",

    // Reports page
    reports_title: "Our Reports",
    reports_subtitle: "Transparency in every step",
    date: "Date",
    read_more: "Read More",

    // Report Detail
    back_to_reports: "Back to Reports",
    gallery_title: "Photo Gallery",

    // Contacts page
    contacts_title: "Get in Touch",
    contacts_subtitle: "We're here to answer your questions",

    contact_email: "Email",
    contact_telegram: "Telegram",
    contact_form_title: "Send Message",

    form_name: "Your Name",
    form_email: "Your Email",
    form_message: "Message",
    form_submit: "Send Message",
    form_success: "Thank you! Your message has been sent successfully.",

    // Business Support page
    business_hero_subtitle: "Empowering entrepreneurs to rebuild and grow their businesses",
    business_apply_now: "Apply Now",
    business_overview_title: "Building Success Together",
    business_overview_text: "Our Business Support Program provides comprehensive assistance to entrepreneurs who are rebuilding their livelihoods. We offer training, mentoring, networking opportunities, and funding support to help you launch or expand your business.",
    business_benefit_1: "Professional business training and skills development",
    business_benefit_2: "One-on-one mentoring from experienced entrepreneurs",
    business_benefit_3: "Access to financial resources and micro-credit programs",
    business_programs_title: "Our Support Programs",
    business_program_training: "Business Training",
    business_program_training_desc: "Comprehensive courses covering business planning, marketing, finance management, and operational excellence.",
    business_program_mentorship: "Mentorship & Coaching",
    business_program_mentorship_desc: "Personalized guidance from experienced entrepreneurs to help you navigate challenges and accelerate growth.",
    business_program_networking: "Business Networking",
    business_program_networking_desc: "Connect with other entrepreneurs, potential partners, and investors in our community.",
    business_program_funding: "Funding Support",
    business_program_funding_desc: "Access to grants, micro-credits, and investment opportunities to fund your business ventures.",
    business_process_title: "Our 4-Step Process",
    business_step_assessment: "Assessment",
    business_step_assessment_desc: "We evaluate your business idea and current situation.",
    business_step_planning: "Planning",
    business_step_planning_desc: "Develop a comprehensive business and financial plan.",
    business_step_implementation: "Implementation",
    business_step_implementation_desc: "Get support launching or scaling your business.",
    business_step_monitoring: "Monitoring",
    business_step_monitoring_desc: "Continuous support and guidance as your business grows.",
    business_eligibility_title: "Who Can Apply?",
    business_eligibility_1: "Be at least 18 years old with a viable business idea",
    business_eligibility_2: "Demonstrate commitment to entrepreneurship and growth",
    business_eligibility_3: "Be willing to engage with mentors and complete training",
    business_eligibility_4: "Show potential to create employment opportunities",
    business_cta_title: "Ready to Start Your Journey?",
    business_cta_text: "Join our Business Support Program and connect with mentors, investors, and fellow entrepreneurs who can help you succeed.",

    // Programs page
    programs_title: "Our Support Programs",
    programs_subtitle: "Comprehensive programs designed to help you rebuild and succeed",
    programs_available: "Available Programs",
    program_training_title: "Business Training & Skills Development",
    program_training_short: "Professional courses to enhance your business knowledge",
    program_training_full: "Comprehensive business courses covering essential topics like business planning, digital marketing, financial management, and operational excellence. Our curriculum is designed by industry experts and tailored to your needs.",
    program_training_benefit_1: "Hands-on practical training workshops",
    program_training_benefit_2: "Certification upon successful completion",
    program_training_benefit_3: "Access to learning materials and resources",
    program_training_benefit_4: "Networking with other participants",
    program_training_duration: "3-6 months",
    program_training_cost: "Free",
    program_mentorship_title: "Mentorship & Coaching Program",
    program_mentorship_short: "One-on-one guidance from experienced entrepreneurs",
    program_mentorship_full: "Get personalized guidance from successful entrepreneurs who have been through the journey. Our mentors provide strategic advice, help overcome challenges, and accelerate your business growth.",
    program_mentorship_benefit_1: "One-on-one mentoring sessions",
    program_mentorship_benefit_2: "Personalized business strategy",
    program_mentorship_benefit_3: "Regular progress reviews",
    program_mentorship_benefit_4: "Network access to mentor's connections",
    program_mentorship_duration: "6-12 months",
    program_mentorship_cost: "Free",
    program_networking_title: "Business Networking Events",
    program_networking_short: "Connect with entrepreneurs, partners, and investors",
    program_networking_full: "Join our community events where you can meet other entrepreneurs, potential partners, investors, and service providers. Build valuable relationships that can help grow your business.",
    program_networking_benefit_1: "Monthly networking events",
    program_networking_benefit_2: "Access to investor pitching opportunities",
    program_networking_benefit_3: "Partnership and collaboration opportunities",
    program_networking_benefit_4: "Online community platform",
    program_networking_duration: "Ongoing",
    program_networking_cost: "Free",
    program_grants_title: "Grant & Funding Programs",
    program_grants_short: "Access to financial resources and micro-credits",
    program_grants_full: "We provide grants, micro-credits, and connect you with investors. Our funding programs are designed to support businesses at different stages of development.",
    program_grants_benefit_1: "Grants up to EUR 5,000",
    program_grants_benefit_2: "Micro-credit loans with favorable terms",
    program_grants_benefit_3: "Investment matching services",
    program_grants_benefit_4: "Financial planning assistance",
    program_grants_duration: "3-4 months approval",
    program_grants_cost: "Free application",
    program_accelerator_title: "Business Accelerator Program",
    program_accelerator_short: "Intensive program to scale your business rapidly",
    program_accelerator_full: "Our 6-month accelerator program combines mentoring, training, and funding to help promising businesses scale. Gain access to expert advisors, resources, and investment opportunities.",
    program_accelerator_benefit_1: "Intensive 6-month program",
    program_accelerator_benefit_2: "Funding opportunities up to EUR 25,000",
    program_accelerator_benefit_3: "Expert advisory board",
    program_accelerator_benefit_4: "Demo day and investor pitching",
    program_accelerator_duration: "6 months intensive",
    program_accelerator_cost: "Variable equity",
    program_about: "About This Program",
    program_benefits: "Key Benefits",
    program_duration: "Program Duration",
    program_cost: "Cost",
    program_apply: "Apply Now",
    programs_why_choose: "Why Choose Our Programs",
    programs_feature_1_title: "Expert-Led Programs",
    programs_feature_1_desc: "All programs are designed and led by industry experts with years of experience",
    programs_feature_2_title: "Personalized Support",
    programs_feature_2_desc: "We tailor our programs to match your specific needs and goals",
    programs_feature_3_title: "Community Focused",
    programs_feature_3_desc: "Be part of a supportive community of entrepreneurs and innovators",
    programs_how_apply: "How to Apply",
    programs_apply_step_1_title: "Submit Your Application",
    programs_apply_step_1_desc: "Fill out our online application form with details about your business and goals",
    programs_apply_step_2_title: "Initial Assessment",
    programs_apply_step_2_desc: "Our team reviews your application and conducts an initial assessment",
    programs_apply_step_3_title: "Interview & Approval",
    programs_apply_step_3_desc: "Selected candidates are invited for an interview with our assessment team",
    programs_apply_step_4_title: "Program Enrollment",
    programs_apply_step_4_desc: "Once approved, you'll receive enrollment details and start your program journey",
    programs_cta_title: "Ready to Transform Your Business?",
    programs_cta_text: "Choose the program that best fits your needs and take the first step towards building a successful, sustainable business.",
    programs_cta_button: "Explore Programs",

    // Partners page
    partners_title: "Our Partners",
    partners_subtitle: "Strategic partnerships strengthening our mission and expanding our impact",
    partners_our_partners: "Our Strategic Partners",
    partners_expertise: "Expertise",
    partners_areas: "Areas of Activity",
    partners_role_ecosystem: "Role in Graweo Ecosystem",

    // U-Cloud24
    partner_ucloud_short: "Technology partner providing cloud infrastructure, DevOps support, and AI solutions",
    partner_ucloud_full: "U-Cloud24 is a technology partner of the Graweo Foundation, providing cloud infrastructure, DevOps support, and AI-powered solutions for grant-funded and corporate-sponsored projects. The company helps organizations build secure, scalable, and Europe-compliant digital environments. U-Cloud24 specializes in modern cloud technologies, automated deployments, data analysis tools, and ensuring compliance with GDPR and ISO standards.",
    partner_ucloud_role: "Technology & Infrastructure Partner",
    partner_ucloud_expertise_cloud: "Cloud infrastructure and DevOps services",
    partner_ucloud_expertise_ai: "AI-powered solutions and automation tools",
    partner_ucloud_expertise_security: "Data security and analysis capabilities",
    partner_ucloud_expertise_compliance: "GDPR and ISO compliance expertise",
    partner_ucloud_area_cloud: "Cloud Infrastructure",
    partner_ucloud_area_devops: "DevOps Services",
    partner_ucloud_area_ai: "AI & Automation",
    partner_ucloud_area_security: "Data Security & Compliance",
    partner_ucloud_role_1: "Infrastructure for research and innovation projects",
    partner_ucloud_role_2: "DevOps support for grant-funded teams",
    partner_ucloud_role_3: "AI tools for data analysis and automation",
    partner_ucloud_role_4: "Security and compliance assurance (GDPR, ISO)",

    // Craft-Me
    partner_craftme_short: "Creative partner specializing in video production, visual storytelling, and content creation for social and cultural initiatives",
    partner_craftme_full: "Craft-Me is a creative partner of the Graweo Foundation, specializing in video production, visual storytelling, and content creation for social, educational, and cultural initiatives. The Craft-Me team helps the foundation tell compelling stories, draw attention to important issues, and amplify the impact of projects through professional video and visual content.",
    partner_craftme_role: "Creative & Content Partner",
    partner_craftme_expertise_video: "Professional video production and documentary storytelling",
    partner_craftme_expertise_visual: "Visual content creation and design for digital platforms",
    partner_craftme_expertise_campaigns: "Social media and digital marketing campaigns",
    partner_craftme_expertise_communication: "European communications and multilingual content support",
    partner_craftme_area_video: "Video Production",
    partner_craftme_area_content: "Content Creation",
    partner_craftme_area_social: "Social Media",
    partner_craftme_area_creative: "Creative Campaigns",
    partner_craftme_role_1: "Documentary and social video production",
    partner_craftme_role_2: "Visual materials creation for grant applications",
    partner_craftme_role_3: "Creative campaign development and execution",
    partner_craftme_role_4: "Foundation communications support across Europe",
    // DAOS
    partner_daos_short: "Health partner dedicated to supporting people in preserving their physical and mental well-being through accessible programs and holistic care",
    partner_daos_full: "DAOS is a health partner of the Graweo Foundation, dedicated to helping people preserve their physical and mental health. DAOS develops and implements accessible programs focused on holistic well-being, mental health support, and physical rehabilitation. Together with the foundation, DAOS works to ensure that individuals affected by social and humanitarian challenges have access to quality health support and care.",
    partner_daos_role: "Health & Well-being Partner",
    partner_daos_expertise_1: "Physical health preservation and rehabilitation programs",
    partner_daos_expertise_2: "Mental health support and psychological well-being",
    partner_daos_expertise_3: "Holistic and preventive health care approaches",
    partner_daos_expertise_4: "Health education and community awareness programs",
    partner_daos_area_1: "Physical Health",
    partner_daos_area_2: "Mental Health",
    partner_daos_area_3: "Rehabilitation",
    partner_daos_area_4: "Well-being Programs",
    partner_daos_role_1: "Physical health preservation programs for foundation beneficiaries",
    partner_daos_role_2: "Mental health support and psychological assistance",
    partner_daos_role_3: "Holistic well-being initiatives and health education",
    partner_daos_role_4: "Rehabilitation and recovery support for affected communities",

    partners_visit_website: "Visit Website",
    partners_join_title: "Become a Partner",
    partners_join_desc: "Are you interested in joining the Graweo partnership network? We welcome organizations that share our vision of supporting sustainable development and community empowerment.",
    partners_contact_us: "Contact Us",
    partners_benefits_title: "Benefits of Partnership",
    partnership_benefit_1_title: "Shared Vision",
    partnership_benefit_1_desc: "Work with an organization committed to social impact and sustainable development",
    partnership_benefit_2_title: "Technical Excellence",
    partnership_benefit_2_desc: "Access to professional expertise and resources across multiple sectors",
    partnership_benefit_3_title: "Sustainable Growth",
    partnership_benefit_3_desc: "Build lasting solutions that create positive environmental and social impact",
    partnership_benefit_4_title: "Network Expansion",
    partnership_benefit_4_desc: "Connect with like-minded organizations and expand your influence",
    partners_values_title: "Partnership Values",
    partners_value_1_title: "Integrity & Transparency",
    partners_value_1_desc: "We operate with full transparency and maintain the highest ethical standards in all partnerships and operations.",
    partners_value_2_title: "Sustainability",
    partners_value_2_desc: "We prioritize long-term sustainable solutions over quick fixes, ensuring lasting positive impact.",
    partners_value_3_title: "Collaboration",
    partners_value_3_desc: "We believe in the power of partnership and work closely with our partners to achieve shared goals.",
    partners_value_4_title: "Impact-Driven",
    partners_value_4_desc: "Every decision is guided by our commitment to creating meaningful, measurable positive change.",
    partners_cta_title: "Ready to Make a Difference Together?",
    partners_cta_text: "Join our network of strategic partners and help us transform lives through sustainable development and community support.",
    partners_cta_button: "Explore Partnership",
    learn_more: "Learn More",

    // 404 Page
    notfound_title: "Page Not Found",
    notfound_description: "The page you're looking for doesn't exist or has been moved. Let's get you back on track!",
    notfound_home: "Go to Home",
    notfound_back: "Go Back",
    notfound_help: "Need help finding something?",
    notfound_contact: "Contact us for assistance",

    // Footer
    footer_tagline: "Supporting recovery and rebuilding",
    footer_links: "Quick Links",
    footer_contact: "Contact Information",
    footer_rights: "All rights reserved",
    footer_gdpr_link: "Privacy & GDPR Policy",

    // GDPR Policy page
    gdpr_badge: "GDPR Compliance",
    gdpr_title: "Privacy & GDPR Policy",
    gdpr_subtitle: "How we collect, use, and protect your personal data",
    gdpr_updated: "Last updated: March 2026",
    gdpr_intro_title: "Introduction",
    gdpr_intro_text: "The Graweo Charitable Foundation is committed to protecting your personal data in full compliance with the General Data Protection Regulation (GDPR) (EU) 2016/679. This policy explains what data we collect, how we use it, and what rights you have as a data subject. By using our website and services, you acknowledge that you have read this policy and consent to the processing of your personal data as described herein.",
    gdpr_data_title: "What Personal Data We Collect",
    gdpr_data_text: "We may collect the following categories of personal data: contact information (name, email address) when you submit a contact form or make a donation; payment information securely processed through our certified payment providers (Stripe); usage and analytics data collected automatically when you visit our website (IP address, browser type, pages visited, time on site); and communication data when you contact us via email or Telegram.",
    gdpr_purpose_title: "Legal Basis and Purpose of Processing",
    gdpr_purpose_text: "We process your personal data on the following legal bases:\n\n(1) Consent — for newsletter subscriptions and optional marketing communications.\n\n(2) Contractual necessity — to process donations and provide our charitable services.\n\n(3) Legitimate interests — to improve our website and services, ensure security, and prevent fraud.\n\n(4) Legal obligation — to comply with applicable laws and regulations, including financial and tax reporting requirements.",
    gdpr_rights_title: "Your Rights Under GDPR",
    gdpr_rights_intro: "As a data subject under GDPR, you are entitled to the following rights. To exercise any of them, please contact us at info@graweo.org.",
    gdpr_right_access: "Right of Access",
    gdpr_right_access_desc: "You have the right to request a copy of the personal data we hold about you, along with information about how it is used.",
    gdpr_right_deletion: "Right to Erasure",
    gdpr_right_deletion_desc: "You may request deletion of your personal data when it is no longer necessary for the purposes for which it was collected.",
    gdpr_right_portability: "Right to Data Portability",
    gdpr_right_portability_desc: "You have the right to receive your personal data in a structured, commonly used, and machine-readable format and to transfer it to another controller.",
    gdpr_right_objection: "Right to Object",
    gdpr_right_objection_desc: "You may object to the processing of your personal data for direct marketing purposes or on grounds relating to your particular situation.",
    gdpr_right_restriction: "Right to Restriction",
    gdpr_right_restriction_desc: "You have the right to request that we restrict the processing of your personal data in certain circumstances.",
    gdpr_right_correction: "Right to Rectification",
    gdpr_right_correction_desc: "You have the right to request correction of inaccurate or incomplete personal data that we hold about you.",
    gdpr_tech_title: "Technical Infrastructure & Data Security",
    gdpr_tech_text_before: "Our website and digital infrastructure are hosted and maintained by",
    gdpr_tech_text_after: "— our technology partner specialising in secure, GDPR-compliant cloud environments. U-Cloud24 provides cloud infrastructure, DevOps support, and data security services, ensuring that all personal data is stored and processed in accordance with European data protection standards. U-Cloud24 acts as a data processor under GDPR and operates in compliance with ISO security standards.",
    gdpr_tech_visit: "Learn more about U-Cloud24's technical capabilities at",
    gdpr_cookies_title: "Cookies and Analytics",
    gdpr_cookies_text: "Our website uses cookies and Google Analytics (via Google Tag Manager, ID: G-9E9JFKGHKN) to understand how visitors interact with our content. This includes strictly necessary cookies for website functionality and analytics cookies that help us improve our services. Analytics data is anonymised where possible. You may disable non-essential cookies through your browser settings at any time.",
    gdpr_consent_title: "Your Consent",
    gdpr_consent_text: "By using this website, submitting a contact form, or making a donation, you confirm that you have read and understood this Privacy & GDPR Policy and consent to the processing of your personal data as described herein. You have the right to withdraw your consent at any time by contacting us — withdrawal of consent does not affect the lawfulness of processing carried out before withdrawal.",
    gdpr_contact_title: "Contact Us for Data Requests",
    gdpr_contact_text: "To exercise any of your GDPR rights, or if you have questions about how we handle your personal data, please contact our Data Protection Officer:",
    gdpr_contact_form_link: "Use Contact Form",
  },

  pl: {
    nav_home: "Strona główna",
    nav_about: "O nas",
    nav_business: "Wsparcie Biznesu",
    nav_programs: "Programy",
    nav_partners: "Partnerzy",
    nav_donate: "Wspieraj",
    nav_reports: "Raporty",
    nav_contacts: "Kontakt",

    hero_title: "Tworzenie Nadziei Poprzez Wsparcie",
    hero_subtitle: "Fundacja Charytatywna Graweo",
    hero_description: "Tworzymy warunki dla ludzi, którzy przeżyli trudne okoliczności, aby mogli odbudować swoje życie, pracę i godność",
    hero_cta: "Wspieraj Teraz",

    about_title: "O Fundacji",
    about_description: "Graweo to fundacja charytatywna poświęcona wspieraniu ludzi w procesie odbudowy po trudnościach. Koncentrujemy się na wsparciu dla odbudowy, reintegracji i przywracania źródeł utrzymania.",

    directions_title: "Kierunki Pomocy",
    direction_humanitarian: "Wsparcie Niezbędne",
    direction_humanitarian_desc: "Zasoby, pomoc i niezbędne przedmioty dla odbudowy",
    direction_idps: "Reintegracja",
    direction_idps_desc: "Integracja społeczna, wsparcie prawne",
    direction_business: "Odbudowa Źródeł Utrzymania",
    direction_business_desc: "Szkolenia, wsparcie biznesu, pomoc w zatrudnieniu",

    howwework_title: "Jak Pracujemy",
    howwework_step1: "Rozumiemy Potrzeby",
    howwework_step1_desc: "Analizujemy sytuacje i oceniamy okoliczności poszczególnych osób",
    howwework_step2: "Mobilizujemy Zasoby",
    howwework_step2_desc: "Pozyskujemy wsparcie i znajdujemy partnerów",
    howwework_step3: "Zapewniamy Pomoc",
    howwework_step3_desc: "Udzielamy dostosowanego wsparcia tym, którzy ich potrzebują",
    howwework_step4: "Raportujemy i Uczymy się",
    howwework_step4_desc: "Pełna przejrzystość i ciągłe doskonalenie",

    latest_reports: "Najnowsze Raporty",
    view_report: "Zobacz Raport",
    all_reports: "Wszystkie Raporty",
    video_title: "Graweo w Działaniu",

    mission_title: "Nasza Misja",
    mission_text: "Naszą misją jest tworzenie warunków, w których ludzie, którzy przeżyli trudne okoliczności, mogą odbudować swoje życie, pracę i poczucie godności. Działamy bez granic, pomagając tam, gdzie wsparcie jest najbardziej potrzebne, i wzmacniając nadzieję na zrównoważoną przyszłość.",

    goals_title: "Nasze Cele",
    goal1: "Zapewnienie niezbędnego wsparcia osobom w sytuacji podatności",
    goal2: "Umożliwienie pomyślnej reintegracji",
    goal3: "Wspomożenie odbudowy źródeł utrzymania i niezależności gospodarczej",
    goal4: "Utrzymanie pełnej przejrzystości wszystkich działań",

    legal_title: "Informacje Prawne",
    legal_name: "Nazwa:",
    legal_name_value: "Fundacja Charytatywna GRAWEO",
    legal_registration: "Rejestracja:",
    legal_country: "Kraj:",
    legal_address: "Adres:",
    legal_country_value: "Ukraina",
    legal_address_value: "Charków, Ukraina",

    requisites_title: "Dane Bankowe",
    requisites_ukraine: "Ukraina",
    requisites_poland: "Polska",
    requisites_account: "Konto:",
    requisites_bank: "Bank:",
    requisites_swift: "SWIFT:",
    requisites_iban: "IBAN:",

    donate_title: "Wspieraj Naszą Misję",
    donate_subtitle: "Twój wkład pomaga nam zapewnić niezbędną pomoc potrzebującym",

    crypto_title: "Darowizny Kryptowalutowe",
    crypto_subtitle: "Natychmiastowe i bezpieczne",
    copy_address: "Kopiuj Adres",
    address_copied: "Adres skopiowany!",

    bank_title: "Przelew Bankowy",
    card_coming_soon: "Wkrótce — szczegóły przelewu bankowego będą wkrótce dostępne.",
    bank_ukraine: "Ukraina (UAH)",
    bank_poland: "Polska (PLN/EUR)",

    card_title: "Płatność Kartą",
    card_button: "Darowizna kartą",
    card_description: "Szybka i bezpieczna płatność kartą kredytową lub debetową za pośrednictwem Stripe",

    currency_select_title: "Wybierz walutę darowizny",
    currency_select_subtitle: "Wybierz walutę, w której chcesz przekazać darowiznę",
    currency_donate_button: "Przekaż darowiznę",
    currency_stripe_note: "Zostaniesz przekierowany na bezpieczną stronę płatności Stripe",

    purpose_title: "Cel Darowizny",
    purpose_humanitarian: "Wsparcie Niezbędne",
    purpose_idps: "Reintegracja",
    purpose_business: "Odbudowa Źródeł Utrzymania",
    purpose_other: "Inny",

    reports_title: "Nasze Raporty",
    reports_subtitle: "Przejrzystość na każdym kroku",
    date: "Data",
    read_more: "Czytaj Więcej",

    back_to_reports: "Powrót do Raportów",
    gallery_title: "Galeria Zdjęć",

    contacts_title: "Skontaktuj się z Nami",
    contacts_subtitle: "Jesteśmy tutaj, aby odpowiedzieć na Twoje pytania",

    contact_email: "Email",
    contact_telegram: "Telegram",
    contact_form_title: "Wyślij Wiadomość",

    form_name: "Twoje Imię",
    form_email: "Twój Email",
    form_message: "Wiadomość",
    form_submit: "Wyślij Wiadomość",
    form_success: "Dziękujemy! Twoja wiadomość została wysłana pomyślnie.",

    // Business Support page
    business_hero_subtitle: "Wspieranie przedsiębiorców w odbudowie i rozwijaniu swoich biznesów",
    business_apply_now: "Złóż Aplikację",
    business_overview_title: "Budowanie Sukcesu Razem",
    business_overview_text: "Nasz Program Wsparcia Biznesu zapewnia wszechstronną pomoc przedsiębiorcom odbudowującym swoje źródła utrzymania. Oferujemy szkolenia, coaching, okazje networkingowe i wsparcie finansowe, aby pomóc Ci uruchomić lub rozwijać swój biznes.",
    business_benefit_1: "Zawodowe szkolenia biznesowe i rozwój umiejętności",
    business_benefit_2: "Indywidualny coaching od doświadczonych przedsiębiorców",
    business_benefit_3: "Dostęp do zasobów finansowych i programów mikrokredytów",
    business_programs_title: "Nasze Programy Wsparcia",
    business_program_training: "Szkolenia Biznesowe",
    business_program_training_desc: "Kompleksowe kursy obejmujące planowanie biznesu, marketing, zarządzanie finansami i doskonałość operacyjną.",
    business_program_mentorship: "Mentoring i Coaching",
    business_program_mentorship_desc: "Spersonalizowane wskazówki od doświadczonych przedsiębiorców, aby pomóc Ci pokonać wyzwania i przyspieszyć wzrost.",
    business_program_networking: "Networking Biznesowy",
    business_program_networking_desc: "Nawiąż kontakty z innymi przedsiębiorcami, potencjalnymi partnerami i inwestorami w naszej społeczności.",
    business_program_funding: "Wsparcie Finansowe",
    business_program_funding_desc: "Dostęp do dotacji, mikrokredytów i możliwości inwestycji, aby sfinansować swoje przedsięwzięcia biznesowe.",
    business_process_title: "Nasz 4-Etapowy Proces",
    business_step_assessment: "Ocena",
    business_step_assessment_desc: "Oceniamy Twój pomysł na biznes i aktualną sytuację.",
    business_step_planning: "Planowanie",
    business_step_planning_desc: "Opracuj kompleksowy plan biznesu i finansowy.",
    business_step_implementation: "Wdrażanie",
    business_step_implementation_desc: "Uzyskaj wsparcie przy uruchomieniu lub skalowaniu swojego biznesu.",
    business_step_monitoring: "Monitorowanie",
    business_step_monitoring_desc: "Ciągłe wsparcie i wytyczne w miarę wzrostu Twojego biznesu.",
    business_eligibility_title: "Kto Może Się Starać?",
    business_eligibility_1: "Mieć co najmniej 18 lat z realnym pomysłem na biznes",
    business_eligibility_2: "Wykazać zaangażowanie w przedsiębiorczość i wzrost",
    business_eligibility_3: "Być gotowym do współpracy z mentorami i ukończenia szkolenia",
    business_eligibility_4: "Wykazywać potencjał do tworzenia miejsc pracy",
    business_cta_title: "Gotowy Aby Rozpocząć Swoją Podróż?",
    business_cta_text: "Dołącz do naszego Programu Wsparcia Biznesu i połącz się z mentorami, inwestorami i innymi przedsiębiorcami, którzy mogą pomóc Ci odnieść sukces.",

    // Programs page
    programs_title: "Nasze Programy Wsparcia",
    programs_subtitle: "Kompleksowe programy zaprojektowane, aby pomóc Ci odbudować się i odnieść sukces",
    programs_available: "Dostępne Programy",
    program_training_title: "Szkolenia Biznesowe i Rozwój Umiejętności",
    program_training_short: "Profesjonalne kursy aby wzbogacić Twoją wiedzę biznesową",
    program_training_full: "Kompleksowe kursy biznesowe obejmujące kluczowe tematy takie jak planowanie biznesu, marketing cyfrowy, zarządzanie finansami i doskonałość operacyjna. Nasz program został zaprojektowany przez ekspertów branży i dostosowany do Twoich potrzeb.",
    program_training_benefit_1: "Praktyczne warsztaty szkoleniowe",
    program_training_benefit_2: "Certyfikat po pomyślnym ukończeniu",
    program_training_benefit_3: "Dostęp do materiałów edukacyjnych",
    program_training_benefit_4: "Networking z innymi uczestnikami",
    program_training_duration: "3-6 miesięcy",
    program_training_cost: "Bezpłatny",
    program_mentorship_title: "Program Mentoringu i Coachingu",
    program_mentorship_short: "Indywidualne wskazówki od doświadczonych przedsiębiorców",
    program_mentorship_full: "Otrzymaj spersonalizowane wskazówki od odnoszących sukcesy przedsiębiorców. Nasi mentorzy udzielają strategicznych porad, pomagają przezwyciężać wyzwania i przyspieszają wzrost Twojego biznesu.",
    program_mentorship_benefit_1: "Indywidualne sesje mentoringu",
    program_mentorship_benefit_2: "Spersonalizowana strategia biznesu",
    program_mentorship_benefit_3: "Regularne przeglądy postępów",
    program_mentorship_benefit_4: "Dostęp do sieci mentora",
    program_mentorship_duration: "6-12 miesięcy",
    program_mentorship_cost: "Bezpłatny",
    program_networking_title: "Imprezy Networkingowe",
    program_networking_short: "Nawiąż kontakty z przedsiębiorcami, partnerami i inwestorami",
    program_networking_full: "Dołącz do naszych imprez społeczności, gdzie możesz spotkać innych przedsiębiorców, potencjalnych partnerów, inwestorów i dostawców usług. Buduj cenne relacje, które mogą pomóc rozwijać Twój biznes.",
    program_networking_benefit_1: "Miesięczne imprezy networkingowe",
    program_networking_benefit_2: "Dostęp do okazji pitch dla inwestorów",
    program_networking_benefit_3: "Okazje do partnerstwa i współpracy",
    program_networking_benefit_4: "Platforma społeczności online",
    program_networking_duration: "Ciągły",
    program_networking_cost: "Bezpłatny",
    program_grants_title: "Programy Grantów i Finansowania",
    program_grants_short: "Dostęp do zasobów finansowych i mikrokredytów",
    program_grants_full: "Udzielamy grantów, mikrokredytów i łączymy Cię z inwestorami. Nasze programy finansowania są zaprojektowane, aby wspierać biznes na różnych etapach rozwoju.",
    program_grants_benefit_1: "Granty do 5 000 EUR",
    program_grants_benefit_2: "Mikrokredyty na korzystnych warunkach",
    program_grants_benefit_3: "Usługi dopasowania inwestycji",
    program_grants_benefit_4: "Pomoc w planowaniu finansowym",
    program_grants_duration: "3-4 miesiące zatwierdzenia",
    program_grants_cost: "Bezpłatny wniosek",
    program_accelerator_title: "Program Akceleratora Biznesu",
    program_accelerator_short: "Intensywny program do szybkiego skalowania Twojego biznesu",
    program_accelerator_full: "Nasz 6-miesięczny program akceleratora łączy mentoring, szkolenia i finansowanie, aby pomóc obiecującym biznesom się rozwijać. Uzyskaj dostęp do doradców ekspertów, zasobów i możliwości inwestycji.",
    program_accelerator_benefit_1: "Intensywny program 6 miesięcy",
    program_accelerator_benefit_2: "Możliwości finansowania do 25 000 EUR",
    program_accelerator_benefit_3: "Rada doradców eksperckich",
    program_accelerator_benefit_4: "Demo day i pitch dla inwestorów",
    program_accelerator_duration: "6 miesięcy intensywnie",
    program_accelerator_cost: "Zmienna kapitałowa",
    program_about: "O Tym Programie",
    program_benefits: "Kluczowe Korzyści",
    program_duration: "Czas Trwania Programu",
    program_cost: "Koszt",
    program_apply: "Złóż Aplikację",
    programs_why_choose: "Dlaczego Wybrać Nasze Programy",
    programs_feature_1_title: "Programy Prowadzone przez Ekspertów",
    programs_feature_1_desc: "Wszystkie programy są zaprojektowane i prowadzone przez ekspertów branży z wieloletnim doświadczeniem",
    programs_feature_2_title: "Wsparcie Spersonalizowane",
    programs_feature_2_desc: "Dostosowujemy nasze programy do Twoich konkretnych potrzeb i celów",
    programs_feature_3_title: "Zorientowana na Społeczność",
    programs_feature_3_desc: "Bądź częścią wspierającej społeczności przedsiębiorców i innowatorów",
    programs_how_apply: "Jak Aplikować",
    programs_apply_step_1_title: "Prześlij Swoją Aplikację",
    programs_apply_step_1_desc: "Wypełnij naszą internetową formę aplikacyjną ze szczegółami o swoim biznesie i celach",
    programs_apply_step_2_title: "Wstępna Ocena",
    programs_apply_step_2_desc: "Nasz zespół przegląda Twoją aplikację i przeprowadza wstępną ocenę",
    programs_apply_step_3_title: "Rozmowa i Zatwierdzenie",
    programs_apply_step_3_desc: "Wybrani kandydaci są zaproszeni na rozmowę z naszym zespołem oceny",
    programs_apply_step_4_title: "Rekrutacja do Programu",
    programs_apply_step_4_desc: "Po zatwierdzeniu otrzymasz szczegóły rekrutacji i zaczniesz swoją podróż programową",
    programs_cta_title: "Gotowy Transformować Swój Biznes?",
    programs_cta_text: "Wybierz program, który najlepiej odpowiada Twoim potrzebom i zrób pierwszy krok w kierunku budowania udanego, zrównoważonego biznesu.",
    programs_cta_button: "Eksploruj Programy",

    // Partners page
    partners_title: "Nasi Partnerzy",
    partners_subtitle: "Strategiczne partnerstwa wzmacniające naszą misję i poszerzające nasz wpływ",
    partners_our_partners: "Nasi Partnerzy Strategiczni",
    partners_expertise: "Wiedza i Doświadczenie",
    partners_areas: "Obszary Działalności",
    partners_role_ecosystem: "Rola w Ekosystemie Graweo",

    // U-Cloud24
    partner_ucloud_short: "Partner technologiczny zapewniający infrastrukturę chmurową, wsparcie DevOps i rozwiązania AI",
    partner_ucloud_full: "U-Cloud24 jest partnerem technologicznym Fundacji Graweo, zapewniającym infrastrukturę chmurową, wsparcie DevOps i rozwiązania oparte na AI dla projektów finansowanych z grantów i programów korporacyjnych. Firma pomaga organizacjom budować bezpieczne, skalowalne i zgodne z europejskimi wymogami środowiska cyfrowe. U-Cloud24 specjalizuje się w nowoczesnych technologiach chmury, automatycznych wdrożeniach, narzędziach analityki danych oraz zapewnianiu zgodności ze standardami GDPR i ISO.",
    partner_ucloud_role: "Partner Technologiczny i Infrastrukturalny",
    partner_ucloud_expertise_cloud: "Infrastruktura chmurowa i usługi DevOps",
    partner_ucloud_expertise_ai: "Rozwiązania oparte na AI i narzędzia automatyzacji",
    partner_ucloud_expertise_security: "Bezpieczeństwo danych i możliwości analityczne",
    partner_ucloud_expertise_compliance: "Wiedza w zakresie zgodności z GDPR i ISO",
    partner_ucloud_area_cloud: "Infrastruktura Chmurowa",
    partner_ucloud_area_devops: "Usługi DevOps",
    partner_ucloud_area_ai: "AI i Automatyzacja",
    partner_ucloud_area_security: "Bezpieczeństwo Danych i Zgodność",
    partner_ucloud_role_1: "Infrastruktura dla projektów badawczych i innowacyjnych",
    partner_ucloud_role_2: "Wsparcie DevOps dla zespołów finansowanych grantami",
    partner_ucloud_role_3: "Narzędzia AI do analizy danych i automatyzacji",
    partner_ucloud_role_4: "Gwarancja bezpieczeństwa i zgodności (GDPR, ISO)",

    // Craft-Me
    partner_craftme_short: "Partner kreatywny specjalizujący się w produkcji wideo, wizualnym storytellingu i tworzeniu treści dla inicjatyw społecznych i kulturalnych",
    partner_craftme_full: "Craft-Me jest partnerem kreatywnym Fundacji Graweo, specjalizującym się w produkcji wideo, wizualnym storytellingu i tworzeniu treści dla inicjatyw społecznych, edukacyjnych i kulturalnych. Zespół Craft-Me pomaga fundacji opowiadać przekonujące historie, zwracać uwagę na ważne kwestie i wzmacniać wpływ projektów poprzez profesjonalne materiały wideo i wizualne.",
    partner_craftme_role: "Partner Kreatywny i Zawartości",
    partner_craftme_expertise_video: "Profesjonalna produkcja wideo i storytelling dokumentalny",
    partner_craftme_expertise_visual: "Tworzenie treści wizualnych i projektowanie dla platform cyfrowych",
    partner_craftme_expertise_campaigns: "Kampanie mediów społecznościowych i marketingu cyfrowego",
    partner_craftme_expertise_communication: "Wsparcie komunikacji europejskiej i treści wielojęzyczne",
    partner_craftme_area_video: "Produkcja Wideo",
    partner_craftme_area_content: "Tworzenie Treści",
    partner_craftme_area_social: "Media Społecznościowe",
    partner_craftme_area_creative: "Kampanie Kreatywne",
    partner_craftme_role_1: "Produkcja filmów dokumentalnych i społecznych",
    partner_craftme_role_2: "Tworzenie materiałów wizualnych do wniosków grantowych",
    partner_craftme_role_3: "Opracowanie i realizacja kampanii kreatywnych",
    partner_craftme_role_4: "Wsparcie komunikacji fundacji na terenie Europy",

    partners_visit_website: "Odwiedź Stronę",
    partners_join_title: "Zostań Partnerem",
    partners_join_desc: "Jesteś zainteresowany dołączeniem do sieci partnerów Graweo? Zapraszamy organizacje, które podzielają naszą wizję wspierania zrównoważonego rozwoju i wzmacniania społeczności.",
    partners_contact_us: "Skontaktuj się z Nami",
    partners_benefits_title: "Korzyści Partnerstwa",
    partnership_benefit_1_title: "Wspólna Wizja",
    partnership_benefit_1_desc: "Praca z organizacją zaangażowaną w wpływ społeczny i zrównoważony rozwój",
    partnership_benefit_2_title: "Doskonałość Techniczna",
    partnership_benefit_2_desc: "Dostęp do profesjonalnej wiedzy i zasobów w wielu sektorach",
    partnership_benefit_3_title: "Zrównoważony Wzrost",
    partnership_benefit_3_desc: "Budowanie trwałych rozwiązań o pozytywnym wpływie środowiskowym i społecznym",
    partnership_benefit_4_title: "Rozszerzenie Sieci",
    partnership_benefit_4_desc: "Połącz się z podobnie myślącymi organizacjami i poszerzaj swój wpływ",
    partners_values_title: "Wartości Partnerstwa",
    partners_value_1_title: "Uczciwość i Przejrzystość",
    partners_value_1_desc: "Działamy z pełną przejrzystością i utrzymujemy najwyższe standardy etyczne w całej współpracy i operacjach.",
    partners_value_2_title: "Zrównoważoność",
    partners_value_2_desc: "Priorytetyzujemy długoterminowe rozwiązania zrównoważone niż szybkie rozwiązania, zapewniając trwały pozytywny wpływ.",
    partners_value_3_title: "Współpraca",
    partners_value_3_desc: "Wierzymy w siłę partnerstwa i ściśle współpracujemy z naszymi partnerami, aby osiągnąć wspólne cele.",
    partners_value_4_title: "Nastawienie na Wpływ",
    partners_value_4_desc: "Każda decyzja jest kierowana naszym zaangażowaniem w tworzenie znaczących, mierzalnych pozytywnych zmian.",
    partners_cta_title: "Gotów Razem Zmienić Świat?",
    partners_cta_text: "Dołącz do naszej sieci partnerów strategicznych i pomóż nam transformować życia poprzez zrównoważony rozwój i wsparcie społeczności.",
    partners_cta_button: "Poznaj Partnerstwo",
    learn_more: "Dowiedz się więcej",

    // 404 Page
    notfound_title: "Strona Nie Znaleziona",
    notfound_description: "Strona, której szukasz, nie istnieje lub została przeniesiona. Pozwól nam Ci pomóc!",
    notfound_home: "Przejdź do Strony Głównej",
    notfound_back: "Wróć",
    notfound_help: "Potrzebujesz pomocy w znalezieniu czegoś?",
    notfound_contact: "Skontaktuj się z nami po pomoc",

    footer_tagline: "Wspieramy odbudowę i regenerację",
    footer_links: "Szybkie Linki",
    footer_contact: "Informacje Kontaktowe",
    footer_rights: "Wszelkie prawa zastrzeżone",
    footer_gdpr_link: "Polityka Prywatności i GDPR",

    gdpr_badge: "Zgodność z GDPR",
    gdpr_title: "Polityka Prywatności i GDPR",
    gdpr_subtitle: "Jak zbieramy, używamy i chronimy Twoje dane osobowe",
    gdpr_updated: "Ostatnia aktualizacja: marzec 2026",
    gdpr_intro_title: "Wprowadzenie",
    gdpr_intro_text: "Fundacja Charytatywna Graweo zobowiązuje się do ochrony Twoich danych osobowych zgodnie z Ogólnym Rozporządzeniem o Ochronie Danych (GDPR) (UE) 2016/679. Niniejsza polityka wyjaśnia, jakie dane zbieramy, jak je wykorzystujemy i jakie prawa Ci przysługują. Korzystając z naszej strony i usług, potwierdzasz, że zapoznałeś się z niniejszą polityką i wyrażasz zgodę na przetwarzanie Twoich danych osobowych.",
    gdpr_data_title: "Jakie dane osobowe zbieramy",
    gdpr_data_text: "Możemy zbierać następujące kategorie danych osobowych: dane kontaktowe (imię, adres e-mail) przy wypełnianiu formularzy lub dokonywaniu darowizn; dane płatnicze bezpiecznie przetwarzane przez certyfikowanych dostawców płatności (Stripe); dane użytkowania i analityczne zbierane automatycznie podczas odwiedzin (adres IP, typ przeglądarki, odwiedzone strony); dane komunikacyjne przy kontakcie przez e-mail lub Telegram.",
    gdpr_purpose_title: "Podstawa prawna i cel przetwarzania",
    gdpr_purpose_text: "Przetwarzamy Twoje dane osobowe na następujących podstawach prawnych:\n\n(1) Zgoda — dla subskrypcji newslettera i komunikacji marketingowej.\n\n(2) Konieczność umowna — do przetwarzania darowizn i świadczenia usług.\n\n(3) Uzasadnione interesy — do ulepszania strony i usług oraz zapobiegania oszustwom.\n\n(4) Obowiązek prawny — do przestrzegania obowiązujących przepisów prawa.",
    gdpr_rights_title: "Twoje prawa wynikające z GDPR",
    gdpr_rights_intro: "Jako podmiot danych na podstawie GDPR masz następujące prawa. Aby je wykonać, skontaktuj się z nami pod adresem info@graweo.org.",
    gdpr_right_access: "Prawo dostępu",
    gdpr_right_access_desc: "Masz prawo do żądania kopii swoich danych osobowych, które przechowujemy, wraz z informacją o sposobie ich wykorzystania.",
    gdpr_right_deletion: "Prawo do usunięcia",
    gdpr_right_deletion_desc: "Możesz żądać usunięcia swoich danych osobowych, gdy nie są już niezbędne do celów, dla których zostały zebrane.",
    gdpr_right_portability: "Prawo do przenoszenia danych",
    gdpr_right_portability_desc: "Masz prawo do otrzymania swoich danych w ustrukturyzowanym, powszechnie używanym i czytelnym maszynowo formacie.",
    gdpr_right_objection: "Prawo sprzeciwu",
    gdpr_right_objection_desc: "Możesz sprzeciwić się przetwarzaniu Twoich danych w celach marketingu bezpośredniego lub z przyczyn związanych z Twoją szczególną sytuacją.",
    gdpr_right_restriction: "Prawo do ograniczenia przetwarzania",
    gdpr_right_restriction_desc: "Masz prawo do żądania ograniczenia przetwarzania Twoich danych w określonych okolicznościach.",
    gdpr_right_correction: "Prawo do sprostowania",
    gdpr_right_correction_desc: "Masz prawo do żądania poprawienia niedokładnych lub niekompletnych danych osobowych, które przechowujemy.",
    gdpr_tech_title: "Infrastruktura Techniczna i Bezpieczeństwo Danych",
    gdpr_tech_text_before: "Nasza strona i infrastruktura cyfrowa są hostowane i utrzymywane przez",
    gdpr_tech_text_after: "— naszego partnera technologicznego specjalizującego się w bezpiecznych środowiskach chmurowych zgodnych z GDPR. U-Cloud24 zapewnia infrastrukturę chmurową, wsparcie DevOps i usługi bezpieczeństwa danych, gwarantując przetwarzanie danych zgodnie z europejskimi standardami ochrony danych. U-Cloud24 działa jako podmiot przetwarzający dane na mocy GDPR i spełnia standardy bezpieczeństwa ISO.",
    gdpr_tech_visit: "Dowiedz się więcej o możliwościach technicznych U-Cloud24 na stronie",
    gdpr_cookies_title: "Pliki Cookie i Analityka",
    gdpr_cookies_text: "Nasza strona używa plików cookie i Google Analytics (przez Google Tag Manager) do analizy interakcji odwiedzających z treściami. Obejmuje to niezbędne pliki cookie do funkcjonowania strony oraz analityczne pliki cookie pomagające ulepszać usługi. Dane analityczne są w miarę możliwości anonimizowane. Możesz wyłączyć nieistotne pliki cookie w ustawieniach przeglądarki.",
    gdpr_consent_title: "Twoja Zgoda",
    gdpr_consent_text: "Korzystając z tej strony, przesyłając formularz kontaktowy lub dokonując darowizny, potwierdzasz, że zapoznałeś się z niniejszą Polityką Prywatności i GDPR i wyrażasz zgodę na przetwarzanie Twoich danych osobowych zgodnie z jej treścią. Masz prawo wycofać zgodę w dowolnym momencie, kontaktując się z nami.",
    gdpr_contact_title: "Kontakt w Sprawach Danych",
    gdpr_contact_text: "Aby skorzystać z praw GDPR lub w przypadku pytań dotyczących przetwarzania danych, skontaktuj się z naszym Inspektorem Ochrony Danych:",
    gdpr_contact_form_link: "Użyj Formularza Kontaktowego",
  },

  ru: {
    nav_home: "Главная",
    nav_about: "О фонде",
    nav_business: "Поддержка Бизнеса",
    nav_programs: "Программы",
    nav_partners: "Партнеры",
    nav_donate: "Пожертвовать",
    nav_reports: "Отчёты",
    nav_contacts: "Контакты",

    hero_title: "Создание Надежды Через Поддержку",
    hero_subtitle: "Благотворительный Фонд Graweo",
    hero_description: "Мы создаём условия для людей, пережившие трудные обстоятельства, чтобы они могли восстановить свою жизнь, работу и достоинство",
    hero_cta: "Пожертвовать",

    about_title: "О Фонде",
    about_description: "Graweo — благотворительный фонд, занимающийся поддержкой людей в процессе восстановления после трудностей. Мы фокусируемся на поддержке для восстановления, реинтеграции и восстановления источников дохода.",

    directions_title: "Направления Помощи",
    direction_humanitarian: "Необходимая Поддержка",
    direction_humanitarian_desc: "Ресурсы, помощь и необходимое для восстановления",
    direction_idps: "Реинтеграция",
    direction_idps_desc: "Интеграция в общество, юридическая помощь",
    direction_business: "Восстановление Источников Дохода",
    direction_business_desc: "Обучение, поддержка бизнеса, содействие в трудоустройстве",

    howwework_title: "Как Мы Работаем",
    howwework_step1: "Понимаем Потребности",
    howwework_step1_desc: "Анализируем ситуации и оцениваем обстоятельства отдельных людей",
    howwework_step2: "Мобилизуем Ресурсы",
    howwework_step2_desc: "Привлекаем поддержку и находим партнёров",
    howwework_step3: "Предоставляем Помощь",
    howwework_step3_desc: "Оказываем адресную помощь тем, кто её нуждается",
    howwework_step4: "Отчитываемся и Учимся",
    howwework_step4_desc: "Полная прозрачность и непрерывное совершенствование",

    latest_reports: "Последние Отчёты",
    view_report: "Смотреть Отчёт",
    all_reports: "Все Отчёты",
    video_title: "Graweo в Действии",

    mission_title: "Наша Миссия",
    mission_text: "Наша миссия — создавать условия, в которых люди, пережившие тяжёлые обстоятельства, могут восстановить свою жизнь, работу и чувство достоинства. Мы действуем без границ, помогая там, где поддержка особенно необходима, и укрепляя надежду на устойчивое будущее.",

    goals_title: "Наши Цели",
    goal1: "Предоставлять необходимую поддержку людям в уязвимых ситуациях",
    goal2: "Обеспечивать успешную реинтеграцию",
    goal3: "Помогать восстанавливать источники дохода и экономическую независимость",
    goal4: "Поддерживать полную прозрачность всех операций",

    legal_title: "Юридическая Информация",
    legal_name: "Название:",
    legal_name_value: "Благотворительный Фонд ГРАВЕО",
    legal_registration: "Регистрация:",
    legal_country: "Страна:",
    legal_address: "Адрес:",
    legal_country_value: "Украина",
    legal_address_value: "Харьков, Украина",

    requisites_title: "Банковские Реквизиты",
    requisites_ukraine: "Украина",
    requisites_poland: "Польша",
    requisites_account: "Счёт:",
    requisites_bank: "Банк:",
    requisites_swift: "SWIFT:",
    requisites_iban: "IBAN:",

    donate_title: "Поддержите Нашу Миссию",
    donate_subtitle: "Ваш вклад помогает нам оказывать необходимую помощь",

    crypto_title: "Криптовалютные Пожертвования",
    crypto_subtitle: "Мгновенно и безопасно",
    copy_address: "Копировать Адрес",
    address_copied: "Адрес скопирован!",

    bank_title: "Банковский Перевод",
    card_coming_soon: "Скоро — реквизиты банковского перевода будут доступны в ближайшее время.",
    bank_ukraine: "Украина (UAH)",
    bank_poland: "Польша (PLN/EUR)",

    card_title: "Оплата Картой",
    card_button: "Пожертвовать Картой",
    card_description: "Быстрая и безопасная оплата кредитной или дебетовой картой через Stripe",

    currency_select_title: "Выберите валюту для пожертвования",
    currency_select_subtitle: "Выберите валюту, в которой хотите сделать пожертвование",
    currency_donate_button: "Пожертвовать",
    currency_stripe_note: "Вы будете перенаправлены на защищённую страницу оплаты Stripe",

    purpose_title: "Назначение Пожертвования",
    purpose_humanitarian: "Необходимая Поддержка",
    purpose_idps: "Реинтеграция",
    purpose_business: "Восстановление Источников Дохода",
    purpose_other: "Другое",

    reports_title: "Наши Отчёты",
    reports_subtitle: "Прозрачность на каждом шаге",
    date: "Дата",
    read_more: "Читать Далее",

    back_to_reports: "Назад к Отчётам",
    gallery_title: "Фотогалерея",

    contacts_title: "Свяжитесь с Нами",
    contacts_subtitle: "Мы здесь, чтобы ответить на ваши вопросы",

    contact_email: "Email",
    contact_telegram: "Telegram",
    contact_form_title: "Отправить Сообщение",

    form_name: "Ваше Имя",
    form_email: "Ваш Email",
    form_message: "Сообщение",
    form_submit: "Отправить Сообщение",
    form_success: "Спасибо! Ваше сообщение успешно отправлено.",

    // Business Support page
    business_hero_subtitle: "Поддержка предпринимателей в восстановлении и развитии их бизнеса",
    business_apply_now: "Подать Заявку",
    business_overview_title: "Построение Успеха Вместе",
    business_overview_text: "Наша Программа Поддержки Бизнеса предоставляет комплексную помощь предпринимателям, восстанавливающим свои источники дохода. Мы предлагаем обучение, наставничество, сетевые возможности и финансовую поддержку, чтобы помочь вам запустить или расширить свой бизнес.",
    business_benefit_1: "Профессиональное обучение бизнесу и развитие навыков",
    business_benefit_2: "Индивидуальное наставничество от опытных предпринимателей",
    business_benefit_3: "Доступ к финансовым ресурсам и программам микрокредитования",
    business_programs_title: "Наши Программы Поддержки",
    business_program_training: "Обучение Бизнесу",
    business_program_training_desc: "Комплексные курсы, охватывающие бизнес-планирование, маркетинг, управление финансами и операционное совершенство.",
    business_program_mentorship: "Наставничество и Коучинг",
    business_program_mentorship_desc: "Персональное руководство от опытных предпринимателей, чтобы помочь вам преодолеть вызовы и ускорить рост.",
    business_program_networking: "Деловое Сетевое Взаимодействие",
    business_program_networking_desc: "Свяжитесь с другими предпринимателями, потенциальными партнерами и инвесторами в нашем сообществе.",
    business_program_funding: "Финансовая Поддержка",
    business_program_funding_desc: "Доступ к грантам, микрокредитам и инвестиционным возможностям для финансирования ваших бизнес-идей.",
    business_process_title: "Наш 4-Этапный Процесс",
    business_step_assessment: "Оценка",
    business_step_assessment_desc: "Мы оцениваем вашу бизнес-идею и текущую ситуацию.",
    business_step_planning: "Планирование",
    business_step_planning_desc: "Разработайте комплексный бизнес-план и финансовый план.",
    business_step_implementation: "Реализация",
    business_step_implementation_desc: "Получайте поддержку при запуске или масштабировании вашего бизнеса.",
    business_step_monitoring: "Мониторинг",
    business_step_monitoring_desc: "Непрерывная поддержка и руководство по мере роста вашего бизнеса.",
    business_eligibility_title: "Кто Может Подать Заявку?",
    business_eligibility_1: "Быть старше 18 лет с жизнеспособной бизнес-идеей",
    business_eligibility_2: "Продемонстрировать приверженность предпринимательству и росту",
    business_eligibility_3: "Быть готовым к сотрудничеству с наставниками и прохождению обучения",
    business_eligibility_4: "Показать потенциал создания рабочих мест",
    business_cta_title: "Готовы Начать Свой Путь?",
    business_cta_text: "Присоединитесь к нашей Программе Поддержки Бизнеса и свяжитесь с наставниками, инвесторами и другими предпринимателями, которые могут помочь вам добиться успеха.",

    // Programs page
    programs_title: "Наши Программы Поддержки",
    programs_subtitle: "Комплексные программы, разработанные для помощи в восстановлении и достижении успеха",
    programs_available: "Доступные Программы",
    program_training_title: "Обучение Бизнесу и Развитие Навыков",
    program_training_short: "Профессиональные курсы для расширения деловых знаний",
    program_training_full: "Комплексные курсы по бизнесу, охватывающие основные темы, такие как бизнес-планирование, цифровой маркетинг, управление финансами и операционное совершенство. Наша программа разработана отраслевыми экспертами и адаптирована к вашим потребностям.",
    program_training_benefit_1: "Практические семинары обучения",
    program_training_benefit_2: "Сертификат при успешном завершении",
    program_training_benefit_3: "Доступ к учебным материалам и ресурсам",
    program_training_benefit_4: "Сетевое взаимодействие с другими участниками",
    program_training_duration: "3-6 месяцев",
    program_training_cost: "Бесплатно",
    program_mentorship_title: "Программа Наставничества и Коучинга",
    program_mentorship_short: "Индивидуальное руководство от опытных предпринимателей",
    program_mentorship_full: "Получайте персональное руководство от успешных предпринимателей, которые прошли этот путь. Наши наставники предоставляют стратегические советы, помогают преодолевать вызовы и ускоряют рост вашего бизнеса.",
    program_mentorship_benefit_1: "Индивидуальные сессии наставничества",
    program_mentorship_benefit_2: "Персональная бизнес-стратегия",
    program_mentorship_benefit_3: "Регулярные обзоры прогресса",
    program_mentorship_benefit_4: "Доступ к сети наставника",
    program_mentorship_duration: "6-12 месяцев",
    program_mentorship_cost: "Бесплатно",
    program_networking_title: "Деловые Сетевые События",
    program_networking_short: "Встречи с предпринимателями, партнёрами и инвесторами",
    program_networking_full: "Присоединитесь к нашим общественным мероприятиям, где вы сможете встретить других предпринимателей, потенциальных партнёров, инвесторов и поставщиков услуг. Создавайте ценные связи, которые помогут расти вашему бизнесу.",
    program_networking_benefit_1: "Ежемесячные сетевые события",
    program_networking_benefit_2: "Доступ к возможностям питча для инвесторов",
    program_networking_benefit_3: "Возможности партнёрства и сотрудничества",
    program_networking_benefit_4: "Платформа онлайн-сообщества",
    program_networking_duration: "Постоянно",
    program_networking_cost: "Бесплатно",
    program_grants_title: "Программы Грантов и Финансирования",
    program_grants_short: "Доступ к финансовым ресурсам и микрокредитам",
    program_grants_full: "Мы предоставляем гранты, микрокредиты и соединяем вас с инвесторами. Наши программы финансирования разработаны для поддержки бизнеса на разных этапах развития.",
    program_grants_benefit_1: "Гранты до 5 000 EUR",
    program_grants_benefit_2: "Микрокредиты на благоприятных условиях",
    program_grants_benefit_3: "Услуги по подбору инвестиций",
    program_grants_benefit_4: "Помощь в финансовом планировании",
    program_grants_duration: "3-4 месяца одобрения",
    program_grants_cost: "Бесплатная подача",
    program_accelerator_title: "Программа Акселератора Бизнеса",
    program_accelerator_short: "Интенсивная программа для быстрого масштабирования вашего бизнеса",
    program_accelerator_full: "Наша 6-месячная программа акселератора сочетает наставничество, обучение и финансирование для помощи перспективным бизнесам в развитии. Получите доступ к консультантам экспертов, ресурсам и инвестиционным возможностям.",
    program_accelerator_benefit_1: "Интенсивная программа 6 месяцев",
    program_accelerator_benefit_2: "Возможности финансирования до 25 000 EUR",
    program_accelerator_benefit_3: "Совет экспертных консультантов",
    program_accelerator_benefit_4: "День демонстрации и питч для инвесторов",
    program_accelerator_duration: "6 месяцев интенсивно",
    program_accelerator_cost: "Переменный капитал",
    program_about: "Об Этой Программе",
    program_benefits: "Ключевые Преимущества",
    program_duration: "Продолжительность Программы",
    program_cost: "Стоимость",
    program_apply: "Подать Заявку",
    programs_why_choose: "Почему Выбрать Наши Программы",
    programs_feature_1_title: "Программы, Ведущиеся Экспертами",
    programs_feature_1_desc: "Все программы разработаны и ведутся отраслевыми экспертами с многолетним опытом",
    programs_feature_2_title: "Персонализированная Поддержка",
    programs_feature_2_desc: "Мы адаптируем наши программы к вашим конкретным потребностям и целям",
    programs_feature_3_title: "Ориентированы на Сообщество",
    programs_feature_3_desc: "Будьте частью поддерживающего сообщества предпринимателей и инноваторов",
    programs_how_apply: "Как Подать Заявку",
    programs_apply_step_1_title: "Подайте Свою Заявку",
    programs_apply_step_1_desc: "Заполните нашу онлайн-форму заявки со сведениями о вашем бизнесе и целях",
    programs_apply_step_2_title: "Первичная Оценка",
    programs_apply_step_2_desc: "Наша команда проверяет вашу заявку и проводит первичную оценку",
    programs_apply_step_3_title: "Интервью и Одобрение",
    programs_apply_step_3_desc: "Выбранные кандидаты приглашаются на интервью с нашей командой оценки",
    programs_apply_step_4_title: "Набор в Программу",
    programs_apply_step_4_desc: "После одобрения вы получите детали набора и начнёте свой путь в программе",
    programs_cta_title: "Готовы Трансформировать Свой Бизнес?",
    programs_cta_text: "Выберите программу, которая лучше всего соответствует вашим потребностям, и сделайте первый шаг к созданию успешного, устойчивого бизнеса.",
    programs_cta_button: "Изучить Программы",

    // Partners page
    partners_title: "Наши Партнеры",
    partners_subtitle: "Стратегические партнерства, укрепляющие нашу миссию и расширяющие наше влияние",
    partners_our_partners: "Наши Стратегические Партнеры",
    partners_expertise: "Экспертиза",
    partners_areas: "Области Деятельности",
    partners_role_ecosystem: "Роль в Экосистеме Graweo",

    // U-Cloud24
    partner_ucloud_short: "Технологический партнёр, предоставляющий облачную инфраструктуру, DevOps-поддержку и AI-решения",
    partner_ucloud_full: "U-Cloud24 — технологический партнёр фонда Graweo, предоставляющий облачную инфраструктуру, DevOps-поддержку и AI-решения для проектов, финансируемых грантами и корпоративными программами. Компания помогает организациям создавать безопасные, масштабируемые и соответствующие европейским требованиям цифровые среды. U-Cloud24 специализируется на современных облачных технологиях, автоматизированных развёртываниях, инструментах анализа данных и обеспечении соответствия стандартам GDPR и ISO.",
    partner_ucloud_role: "Технологический и Инфраструктурный Партнер",
    partner_ucloud_expertise_cloud: "Облачная инфраструктура и услуги DevOps",
    partner_ucloud_expertise_ai: "AI-решения и инструменты автоматизации",
    partner_ucloud_expertise_security: "Безопасность данных и возможности анализа",
    partner_ucloud_expertise_compliance: "Экспертиза в соответствии GDPR и ISO",
    partner_ucloud_area_cloud: "Облачная Инфраструктура",
    partner_ucloud_area_devops: "DevOps Услуги",
    partner_ucloud_area_ai: "AI и Автоматизация",
    partner_ucloud_area_security: "Безопасность Данных и Соответствие",
    partner_ucloud_role_1: "Инфраструктура для исследовательских и инновационных проектов",
    partner_ucloud_role_2: "DevOps-поддержка команд, работающих по грантам",
    partner_ucloud_role_3: "AI-инструменты для анализа данных и автоматизации",
    partner_ucloud_role_4: "Обеспечение безопасности и соответствия (GDPR, ISO)",

    // Craft-Me
    partner_craftme_short: "Творческий партнёр, специализирующийся на видеопродакшене, визуальном сторителлинге и создании контента для социальных и культурных инициатив",
    partner_craftme_full: "Craft-Me — творческий партнёр фонда Graweo, специализирующийся на видеопродакшене, визуальном сторителлинге и создании контента для социальных, образовательных и культурных инициатив. Команда Craft-Me помогает фонду рассказывать убедительные истории, привлекать внимание к важным темам и усиливать влияние проектов через профессиональные видео и визуальные материалы.",
    partner_craftme_role: "Творческий и Контент-партнер",
    partner_craftme_expertise_video: "Профессиональное видеопроизводство и документальный сторителлинг",
    partner_craftme_expertise_visual: "Создание визуального контента и дизайн для цифровых платформ",
    partner_craftme_expertise_campaigns: "Кампании в социальных сетях и цифровой маркетинг",
    partner_craftme_expertise_communication: "Поддержка европейских коммуникаций и многоязычный контент",
    partner_craftme_area_video: "Видеопроизводство",
    partner_craftme_area_content: "Создание Контента",
    partner_craftme_area_social: "Социальные Сети",
    partner_craftme_area_creative: "Творческие Кампании",
    partner_craftme_role_1: "Производство документальных и социальных видеороликов",
    partner_craftme_role_2: "Создание визуальных материалов для грантовых заявок",
    partner_craftme_role_3: "Разработка и реализация творческих кампаний",
    partner_craftme_role_4: "Поддержка коммуникаций фонда в Европе",
    // DAOS
    partner_daos_short: "Партнёр в сфере здоровья, посвящённый поддержке людей в сохранении физического и ментального благополучия через доступные программы и комплексный уход",
    partner_daos_full: "DAOS — партнёр Фонда Graweo в сфере здоровья, посвящённый помощи людям в сохранении физического и ментального здоровья. DAOS разрабатывает и реализует доступные программы, ориентированные на комплексное благополучие, поддержку психического здоровья и физическую реабилитацию. Совместно с фондом DAOS работает над тем, чтобы люди, затронутые социальными и гуманитарными проблемами, имели доступ к качественной медицинской поддержке.",
    partner_daos_role: "Партнёр по здоровью и благополучию",
    partner_daos_expertise_1: "Программы сохранения физического здоровья и реабилитации",
    partner_daos_expertise_2: "Поддержка психического здоровья и психологического благополучия",
    partner_daos_expertise_3: "Комплексные и профилактические подходы к охране здоровья",
    partner_daos_expertise_4: "Просвещение в области здоровья и повышение осведомлённости сообщества",
    partner_daos_area_1: "Физическое Здоровье",
    partner_daos_area_2: "Психическое Здоровье",
    partner_daos_area_3: "Реабилитация",
    partner_daos_area_4: "Программы Благополучия",
    partner_daos_role_1: "Программы сохранения физического здоровья для благополучателей фонда",
    partner_daos_role_2: "Поддержка психического здоровья и психологическая помощь",
    partner_daos_role_3: "Инициативы комплексного благополучия и просвещение в области здоровья",
    partner_daos_role_4: "Поддержка реабилитации и восстановления пострадавших сообществ",

    partners_visit_website: "Посетить Сайт",
    partners_join_title: "Станьте Партнером",
    partners_join_desc: "Вы заинтересованы в присоединении к сети партнеров Graweo? Мы приветствуем организации, которые разделяют нашу видение поддержки устойчивого развития и расширения возможностей сообщества.",
    partners_contact_us: "Связаться с Нами",
    partners_benefits_title: "Преимущества Партнерства",
    partnership_benefit_1_title: "Общее Видение",
    partnership_benefit_1_desc: "Сотрудничество с организацией, привержённой социальному влиянию и устойчивому развитию",
    partnership_benefit_2_title: "Техническое Совершенство",
    partnership_benefit_2_desc: "Доступ к профессиональной экспертизе и ресурсам в различных секторах",
    partnership_benefit_3_title: "Устойчивый Рост",
    partnership_benefit_3_desc: "Создание долгосрочных решений с положительным влиянием на окружающую среду и общество",
    partnership_benefit_4_title: "Расширение Сети",
    partnership_benefit_4_desc: "Подключитесь к единомышленным организациям и расширьте своё влияние",
    partners_values_title: "Ценности Партнерства",
    partners_value_1_title: "Честность и Прозрачность",
    partners_value_1_desc: "Мы работаем с полной прозрачностью и придерживаемся высочайших этических стандартов во всех партнерских отношениях и операциях.",
    partners_value_2_title: "Устойчивость",
    partners_value_2_desc: "Мы отдаём приоритет долгосрочным устойчивым решениям вместо быстрых исправлений, обеспечивая длительное положительное влияние.",
    partners_value_3_title: "Сотрудничество",
    partners_value_3_desc: "Мы верим в мощь партнерства и тесно сотрудничаем с нашими партнёрами для достижения общих целей.",
    partners_value_4_title: "Ориентированность на Влияние",
    partners_value_4_desc: "Каждое решение руководствуется нашей приверженностью созданию значимых, измеримых позитивных изменений.",
    partners_cta_title: "Готовы Вместе Изменить Мир?",
    partners_cta_text: "Присоединитесь к нашей сети стратегических партнеров и помогите нам трансформировать жизни посредством устойчивого развития и поддержки сообществ.",
    partners_cta_button: "Узнать о Партнерстве",
    learn_more: "Узнать больше",

    // 404 Page
    notfound_title: "Страница Не Найдена",
    notfound_description: "Страница, которую вы ищете, не существует или была перемещена. Давайте вернём вас на правильный путь!",
    notfound_home: "На Главную",
    notfound_back: "Вернуться",
    notfound_help: "Нужна помощь в поиске?",
    notfound_contact: "Свяжитесь с нами",

    footer_tagline: "Поддержка восстановления и возрождения",
    footer_links: "Быстрые Ссылки",
    footer_contact: "Контактная Информация",
    footer_rights: "Все права защищены",
    footer_gdpr_link: "Политика конфиденциальности и GDPR",

    gdpr_badge: "Соответствие GDPR",
    gdpr_title: "Политика конфиденциальности и GDPR",
    gdpr_subtitle: "Как мы собираем, используем и защищаем ваши персональные данные",
    gdpr_updated: "Обновлено: март 2026",
    gdpr_intro_title: "Введение",
    gdpr_intro_text: "Благотворительный фонд Graweo обязуется защищать ваши персональные данные в полном соответствии с Общим регламентом о защите данных (GDPR) (ЕС) 2016/679. Настоящая политика объясняет, какие данные мы собираем, как их используем и какими правами вы обладаете как субъект данных. Используя наш сайт и услуги, вы подтверждаете, что ознакомились с настоящей политикой и даёте согласие на обработку ваших персональных данных.",
    gdpr_data_title: "Какие персональные данные мы собираем",
    gdpr_data_text: "Мы можем собирать следующие категории персональных данных: контактная информация (имя, адрес электронной почты) при заполнении форм или осуществлении пожертвований; платёжная информация, безопасно обрабатываемая через сертифицированных платёжных провайдеров (Stripe); данные использования и аналитика, собираемые автоматически при посещении сайта (IP-адрес, тип браузера, посещённые страницы); данные коммуникаций при обращении по электронной почте или через Telegram.",
    gdpr_purpose_title: "Правовое основание и цель обработки",
    gdpr_purpose_text: "Мы обрабатываем ваши персональные данные на следующих правовых основаниях:\n\n(1) Согласие — для подписки на рассылку и маркетинговых коммуникаций.\n\n(2) Необходимость исполнения договора — для обработки пожертвований и предоставления услуг.\n\n(3) Законные интересы — для улучшения сайта и услуг, а также предотвращения мошенничества.\n\n(4) Юридическое обязательство — для соблюдения применимых законов и нормативных требований.",
    gdpr_rights_title: "Ваши права по GDPR",
    gdpr_rights_intro: "Как субъект данных по GDPR, вы имеете следующие права. Для их реализации свяжитесь с нами по адресу info@graweo.org.",
    gdpr_right_access: "Право на доступ",
    gdpr_right_access_desc: "Вы вправе запросить копию ваших персональных данных, которые мы храним, а также информацию о том, как они используются.",
    gdpr_right_deletion: "Право на удаление («право быть забытым»)",
    gdpr_right_deletion_desc: "Вы можете запросить удаление ваших персональных данных, когда они более не нужны для целей, для которых были собраны.",
    gdpr_right_portability: "Право на переносимость данных",
    gdpr_right_portability_desc: "Вы вправе получить ваши данные в структурированном, общепринятом и машиночитаемом формате и передать их другому контролёру.",
    gdpr_right_objection: "Право на возражение",
    gdpr_right_objection_desc: "Вы можете возразить против обработки ваших данных в целях прямого маркетинга или по причинам, связанным с вашей конкретной ситуацией.",
    gdpr_right_restriction: "Право на ограничение обработки",
    gdpr_right_restriction_desc: "Вы вправе потребовать ограничения обработки ваших персональных данных в определённых обстоятельствах.",
    gdpr_right_correction: "Право на исправление",
    gdpr_right_correction_desc: "Вы вправе запросить исправление неточных или неполных персональных данных, которые мы храним.",
    gdpr_tech_title: "Техническая инфраструктура и безопасность данных",
    gdpr_tech_text_before: "Наш сайт и цифровая инфраструктура размещены и обслуживаются компанией",
    gdpr_tech_text_after: "— нашим технологическим партнёром, специализирующимся на безопасных облачных средах, соответствующих требованиям GDPR. U-Cloud24 предоставляет облачную инфраструктуру, поддержку DevOps и услуги по безопасности данных, обеспечивая хранение и обработку всех персональных данных в соответствии с европейскими стандартами защиты данных. U-Cloud24 выступает обработчиком данных по GDPR и работает в соответствии со стандартами безопасности ISO.",
    gdpr_tech_visit: "Подробнее о технических возможностях U-Cloud24 на сайте",
    gdpr_cookies_title: "Файлы cookie и аналитика",
    gdpr_cookies_text: "Наш сайт использует файлы cookie и Google Analytics (через Google Tag Manager) для анализа взаимодействия посетителей с контентом. Это включает функциональные файлы cookie, необходимые для работы сайта, и аналитические файлы cookie, помогающие улучшать наши услуги. Аналитические данные по возможности анонимизируются. Вы можете отключить нефункциональные файлы cookie в настройках браузера.",
    gdpr_consent_title: "Ваше согласие",
    gdpr_consent_text: "Используя данный сайт, отправляя контактную форму или осуществляя пожертвование, вы подтверждаете, что прочитали и поняли настоящую Политику конфиденциальности и GDPR и даёте согласие на обработку ваших персональных данных. Вы вправе отозвать согласие в любое время, связавшись с нами.",
    gdpr_contact_title: "Контакт по вопросам данных",
    gdpr_contact_text: "Для реализации любого из ваших прав по GDPR или при наличии вопросов об обработке персональных данных обратитесь к нашему сотруднику по защите данных:",
    gdpr_contact_form_link: "Использовать форму обратной связи",
  },

  uk: {
    nav_home: "Головна",
    nav_about: "Про фонд",
    nav_business: "Підтримка Бізнесу",
    nav_programs: "Програми",
    nav_partners: "Партнери",
    nav_donate: "Пожертвувати",
    nav_reports: "Звіти",
    nav_contacts: "Контакти",

    hero_title: "Створення Надії Через Підтримку",
    hero_subtitle: "Благодійний Фонд Graweo",
    hero_description: "Ми створюємо умови для людей, які пережили складні обставини, щоб вони могли відновити своє життя, роботу та гідність",
    hero_cta: "Підтримати",

    about_title: "Про Фонд",
    about_description: "Graweo — благодійний фонд, присвячений підтримці людей у процесі відновлення після труднощів. Ми зосереджуємося на підтримці для відновлення, реінтеграції та відновлення джерел доходу.",

    directions_title: "Напрямки Допомоги",
    direction_humanitarian: "Необхідна Підтримка",
    direction_humanitarian_desc: "Ресурси, допомога та необхідне для відновлення",
    direction_idps: "Реінтеграція",
    direction_idps_desc: "Інтеграція в суспільство, юридична допомога",
    direction_business: "Відновлення Джерел Доходу",
    direction_business_desc: "Навчання, підтримка бізнесу, сприяння у працевлаштуванні",

    howwework_title: "Як Ми Працюємо",
    howwework_step1: "Розуміємо Потреби",
    howwework_step1_desc: "Аналізуємо ситуації та оцінюємо обставини окремих людей",
    howwework_step2: "Мобілізуємо Ресурси",
    howwework_step2_desc: "Залучаємо підтримку та знаходимо партнерів",
    howwework_step3: "Надаємо Допомогу",
    howwework_step3_desc: "Надаємо цільову допомогу тим, хто її потребує",
    howwework_step4: "Звітуємо та Навчаємось",
    howwework_step4_desc: "Повна прозорість та постійне вдосконалення",

    latest_reports: "Останні Звіти",
    view_report: "Дивитись Звіт",
    all_reports: "Всі Звіти",
    video_title: "Graweo в Дії",

    mission_title: "Наша Місія",
    mission_text: "Наша місія — створювати умови, в яких люди, які пережили складні обставини, можуть відновити своє життя, роботу та почуття гідності. Ми діємо без кордонів, допомагаючи там, де підтримка найбільш потрібна, і укріплюючи надію на стійке майбутнього.",

    goals_title: "Наші Цілі",
    goal1: "Надавати необхідну підтримку людям у вразливих ситуаціях",
    goal2: "Забезпечувати успішну реінтеграцію",
    goal3: "Допомагати відновлювати джерела доходу та економічну незалежність",
    goal4: "Підтримувати повну прозорість усіх операцій",

    legal_title: "Юридична Інформація",
    legal_name: "Назва:",
    legal_name_value: "Благодійний Фонд ГРАВЕО",
    legal_registration: "Реєстрація:",
    legal_country: "Країна:",
    legal_address: "Адреса:",
    legal_country_value: "Україна",
    legal_address_value: "Харків, Україна",

    requisites_title: "Банківські Реквізити",
    requisites_ukraine: "Україна",
    requisites_poland: "Польща",
    requisites_account: "Рахунок:",
    requisites_bank: "Банк:",
    requisites_swift: "SWIFT:",
    requisites_iban: "IBAN:",

    donate_title: "Підтримайте Нашу Місію",
    donate_subtitle: "Ваш внесок допомагає нам надавати необхідну допомогу",

    crypto_title: "Криптовалютні Пожертви",
    crypto_subtitle: "Миттєво та безпечно",
    copy_address: "Копіювати Адресу",
    address_copied: "Адресу скопійовано!",

    bank_title: "Банківський Переказ",
    card_coming_soon: "Незабаром — реквізити банківського переказу будуть доступні найближчим часом.",
    bank_ukraine: "Україна (UAH)",
    bank_poland: "Польща (PLN/EUR)",

    card_title: "Оплата Карткою",
    card_button: "Пожертвувати Карткою",
    card_description: "Швидка та безпечна оплата кредитною або дебетовою карткою через Stripe",

    currency_select_title: "Виберіть валюту пожертви",
    currency_select_subtitle: "Оберіть валюту, в якій хочете зробити пожертву",
    currency_donate_button: "Пожертвувати",
    currency_stripe_note: "Вас буде перенаправлено на захищену сторінку оплати Stripe",

    purpose_title: "Призначення Пожертви",
    purpose_humanitarian: "Необхідна Підтримка",
    purpose_idps: "Реінтеграція",
    purpose_business: "Відновлення Джерел Доходу",
    purpose_other: "Інше",

    reports_title: "Наші Звіти",
    reports_subtitle: "Прозорість на кожному кроці",
    date: "Дата",
    read_more: "Читати Далі",

    back_to_reports: "Назад до Звітів",
    gallery_title: "Фотогалерея",

    contacts_title: "Зв'яжіться з Нами",
    contacts_subtitle: "Ми тут, щоб відповісти на ваші питання",

    contact_email: "Email",
    contact_telegram: "Telegram",
    contact_form_title: "Надіслати Повідомлення",

    form_name: "Ваше Ім'я",
    form_email: "Ваш Email",
    form_message: "Повідомлення",
    form_submit: "Надіслати Повідомлення",
    form_success: "Дякуємо! Ваше повідомлення успішно надіслано.",

    // Business Support page
    business_hero_subtitle: "Підтримка підприємців у відновленні та розвитку їх бізнесу",
    business_apply_now: "Подати Заявку",
    business_overview_title: "Побудова Успіху Разом",
    business_overview_text: "Наша Програма Підтримки Бізнесу надає комплексну допомогу підприємцям, які відновлюють свої джерела доходу. Ми пропонуємо навчання, коучинг, мережевих можливостей та фінансову підтримку, щоб допомогти вам запустити або розширити свій бізнес.",
    business_benefit_1: "Професійне навчання бізнесу та розвиток навичок",
    business_benefit_2: "Індивідуальний коучинг від досвідчених підприємців",
    business_benefit_3: "Доступ до фінансових ресурсів та програм мікрокредитування",
    business_programs_title: "Наші Програми Підтримки",
    business_program_training: "Навчання Бізнесу",
    business_program_training_desc: "Комплексні курси, що охоплюють бізнес-планування, маркетинг, управління фінансами та операційну досконалість.",
    business_program_mentorship: "Коучинг і Наставництво",
    business_program_mentorship_desc: "Персональне керівництво від досвідчених підприємців, щоб допомогти вам подолати виклики та прискорити зростання.",
    business_program_networking: "Ділове Мережування",
    business_program_networking_desc: "Познайомтесь з іншими підприємцями, потенційними партнерами та інвесторами в нашій спільноті.",
    business_program_funding: "Фінансова Підтримка",
    business_program_funding_desc: "Доступ до грантів, мікрокредитів та інвестиційних можливостей для фінансування ваших бізнес-проектів.",
    business_process_title: "Наш 4-Етапний Процес",
    business_step_assessment: "Оцінка",
    business_step_assessment_desc: "Ми оцінюємо вашу бізнес-ідею та поточну ситуацію.",
    business_step_planning: "Планування",
    business_step_planning_desc: "Розробіть комплексний бізнес-план та фінансовий план.",
    business_step_implementation: "Впровадження",
    business_step_implementation_desc: "Отримайте підтримку при запуску або масштабуванні свого бізнесу.",
    business_step_monitoring: "Моніторинг",
    business_step_monitoring_desc: "Безперервна підтримка та керівництво в міру зростання вашого бізнесу.",
    business_eligibility_title: "Хто Може Подати Заявку?",
    business_eligibility_1: "Бути старше 18 років з життєздатною бізнес-ідеєю",
    business_eligibility_2: "Продемонструвати прихильність підприємництву та зростанню",
    business_eligibility_3: "Бути готовим до співпраці з наставниками та проходження навчання",
    business_eligibility_4: "Показати потенціал для створення робочих місць",
    business_cta_title: "Готові Розпочати Свою Подорож?",
    business_cta_text: "Приєднайтесь до нашої Програми Підтримки Бізнесу і зв'яжіться з наставниками, інвесторами та іншими підприємцями, які можуть допомогти вам досягти успіху.",

    // Programs page
    programs_title: "Наші Програми Підтримки",
    programs_subtitle: "Комплексні програми, розроблені для допомоги у відновленні та досягненні успіху",
    programs_available: "Доступні Програми",
    program_training_title: "Навчання Бізнесу та Розвиток Навичок",
    program_training_short: "Професійні курси для розширення ділових знань",
    program_training_full: "Комплексні курси з бізнесу, які охоплюють ключові теми, такі як бізнес-планування, цифровий маркетинг, управління фінансами та операційна досконалість. Наша програма розроблена фахівцями галузі та адаптована до ваших потреб.",
    program_training_benefit_1: "Практичні семінари навчання",
    program_training_benefit_2: "Сертифікат після успішного завершення",
    program_training_benefit_3: "Доступ до навчальних матеріалів та ресурсів",
    program_training_benefit_4: "Мережування з іншими учасниками",
    program_training_duration: "3-6 місяців",
    program_training_cost: "Безплатно",
    program_mentorship_title: "Програма Наставництва та Коучингу",
    program_mentorship_short: "Індивідуальне керівництво від досвідчених підприємців",
    program_mentorship_full: "Отримайте персональне керівництво від успішних підприємців, які пройшли цей шлях. Наші наставники надають стратегічні поради, допомагають подолати виклики та прискорюють ріст вашого бізнесу.",
    program_mentorship_benefit_1: "Індивідуальні сесії наставництва",
    program_mentorship_benefit_2: "Персональна бізнес-стратегія",
    program_mentorship_benefit_3: "Регулярні огляди прогресу",
    program_mentorship_benefit_4: "Доступ до мережі наставника",
    program_mentorship_duration: "6-12 місяців",
    program_mentorship_cost: "Безплатно",
    program_networking_title: "Ділові Мережеві Події",
    program_networking_short: "Встречайтесь з підприємцями, партнерами та інвесторами",
    program_networking_full: "Приєднайтеся до наших спільнотних заходів, де ви можете зустріти інших підприємців, потенційних партнерів, інвесторів та постачальників послуг. Будуйте цінні зв'язки, які допоможуть розвиватися вашому бізнесу.",
    program_networking_benefit_1: "Щомісячні мережеві заходи",
    program_networking_benefit_2: "Доступ до можливостей комунікації з інвесторами",
    program_networking_benefit_3: "Можливості партнерства та співпраці",
    program_networking_benefit_4: "Платформа онлайн-спільноти",
    program_networking_duration: "Постійно",
    program_networking_cost: "Безплатно",
    program_grants_title: "Програми Грантів та Фінансування",
    program_grants_short: "Доступ до фінансових ресурсів та мікрокредитів",
    program_grants_full: "Ми надаємо гранти, мікрокредити та поєднуємо вас з інвесторами. Наші програми фінансування розроблені для підтримки бізнесу на різних етапах розвитку.",
    program_grants_benefit_1: "Гранти до 5 000 EUR",
    program_grants_benefit_2: "Мікрокредити на сприятливих умовах",
    program_grants_benefit_3: "Послуги підбору інвестицій",
    program_grants_benefit_4: "Допомога у фінансовому плануванні",
    program_grants_duration: "3-4 місяці затвердження",
    program_grants_cost: "Безплатна заявка",
    program_accelerator_title: "Програма Акселератора Бізнесу",
    program_accelerator_short: "Інтенсивна програма для швидкого масштабування вашого бізнесу",
    program_accelerator_full: "Наша 6-місячна програма акселератора поєднує наставництво, навчання та фінансування для допомоги перспективним бізнесам у розвитку. Отримайте доступ до консультантів експертів, ресурсів та можливостей інвестування.",
    program_accelerator_benefit_1: "Інтенсивна програма 6 місяців",
    program_accelerator_benefit_2: "Можливості фінансування до 25 000 EUR",
    program_accelerator_benefit_3: "Рада експертних консультантів",
    program_accelerator_benefit_4: "День демонстрації та комунікація з інвесторами",
    program_accelerator_duration: "6 місяців інтенсивно",
    program_accelerator_cost: "Змінний капітал",
    program_about: "Про Цю Програму",
    program_benefits: "Ключові Переваги",
    program_duration: "Тривалість Програми",
    program_cost: "Вартість",
    program_apply: "Подати Заявку",
    programs_why_choose: "Чому Вибрати Наші Програми",
    programs_feature_1_title: "Програми, Проведені Експертами",
    programs_feature_1_desc: "Всі програми розроблені та проводяться фахівцями галузі з багаторічним досвідом",
    programs_feature_2_title: "Персоналізована Підтримка",
    programs_feature_2_desc: "Ми адаптуємо наші програми до ваших конкретних потреб та цілей",
    programs_feature_3_title: "Орієнтовані на Спільноту",
    programs_feature_3_desc: "Будьте частиною підтримуючої спільноти підприємців та інноваторів",
    programs_how_apply: "Як Подати Заявку",
    programs_apply_step_1_title: "Подайте Свою Заявку",
    programs_apply_step_1_desc: "Заповніть нашу онлайн-форму заявки з деталями про ваш бізнес та цілі",
    programs_apply_step_2_title: "Первинна Оцінка",
    programs_apply_step_2_desc: "Наша команда перевіряє вашу заявку та проводить первинну оцінку",
    programs_apply_step_3_title: "Інтерв'ю та Затвердження",
    programs_apply_step_3_desc: "Вибрані кандидати запрошуються на інтерв'ю з нашою командою оцінки",
    programs_apply_step_4_title: "Зараховування в Програму",
    programs_apply_step_4_desc: "Після затвердження ви отримаєте деталі зарахування та почнете свою програмну подорож",
    programs_cta_title: "Готові Трансформувати Свій Бізнес?",
    programs_cta_text: "Виберіть програму, яка найкраще відповідає вашим потребам, і зробіть перший крок до створення успішного, стійкого бізнесу.",
    programs_cta_button: "Дослідити Програми",

    // Partners page
    partners_title: "Наші Партнери",
    partners_subtitle: "Стратегічні партнерства, які зміцнюють нашу місію та розширюють наш вплив",
    partners_our_partners: "Наші Стратегічні Партнери",
    partners_expertise: "Експертиза",
    partners_areas: "Області Діяльності",
    partners_role_ecosystem: "Роль у Екосистемі Graweo",

    // U-Cloud24
    partner_ucloud_short: "Технологічний партнер, який надає хмарну інфраструктуру, підтримку DevOps та AI-рішення",
    partner_ucloud_full: "U-Cloud24 — технологічний партнер фонду Graweo, який надає хмарну інфраструктуру, підтримку DevOps та AI-рішення для проектів, фінансованих грантами та корпоративними програмами. Компанія допомагає організаціям будувати безпечні, масштабовані та відповідні європейським вимогам цифрові середовища. U-Cloud24 спеціалізується на сучасних хмарних технологіях, автоматизованих розгортаннях, інструментах аналітики даних та забезпеченні відповідності стандартам GDPR та ISO.",
    partner_ucloud_role: "Технологічний та Інфраструктурний Партнер",
    partner_ucloud_expertise_cloud: "Хмарна інфраструктура та послуги DevOps",
    partner_ucloud_expertise_ai: "AI-рішення та інструменти автоматизації",
    partner_ucloud_expertise_security: "Безпека даних та можливості аналітики",
    partner_ucloud_expertise_compliance: "Експертиза у відповідності GDPR та ISO",
    partner_ucloud_area_cloud: "Хмарна Інфраструктура",
    partner_ucloud_area_devops: "DevOps Послуги",
    partner_ucloud_area_ai: "AI та Автоматизація",
    partner_ucloud_area_security: "Безпека Даних та Відповідність",
    partner_ucloud_role_1: "Інфраструктура для дослідницьких та інноваційних проектів",
    partner_ucloud_role_2: "Підтримка DevOps для команд, що працюють за грантами",
    partner_ucloud_role_3: "AI-інструменти для аналізу даних та автоматизації",
    partner_ucloud_role_4: "Забезпечення безпеки та відповідності (GDPR, ISO)",

    // Craft-Me
    partner_craftme_short: "Творчий партнер, що спеціалізується на відеопродакшені, візуальному сторітелінгу та створенні контенту для соціальних і культурних ініціатив",
    partner_craftme_full: "Craft-Me — творчий партнер фонду Graweo, що спеціалізується на відеопродакшені, візуальному сторітелінгу та створенні контенту для соціальних, освітніх і культурних ініціатив. Команда Craft-Me допомагає фонду розповідати переконливі історії, привертати увагу до важливих тем та посилювати вплив проектів через професійні відео та візуальні матеріали.",
    partner_craftme_role: "Творчий та Контент-партнер",
    partner_craftme_expertise_video: "Професійне відеовиробництво та документальний сторітелінг",
    partner_craftme_expertise_visual: "Створення візуального контенту та дизайн для цифрових платформ",
    partner_craftme_expertise_campaigns: "Кампанії в соціальних мережах та цифровий маркетинг",
    partner_craftme_expertise_communication: "Підтримка європейських комунікацій та багатомовний контент",
    partner_craftme_area_video: "Відеовиробництво",
    partner_craftme_area_content: "Створення Контенту",
    partner_craftme_area_social: "Соціальні Мережі",
    partner_craftme_area_creative: "Творчі Кампанії",
    partner_craftme_role_1: "Виробництво документальних та соціальних відеороліків",
    partner_craftme_role_2: "Створення візуальних матеріалів для грантових заявок",
    partner_craftme_role_3: "Розробка та реалізація творчих кампаній",
    partner_craftme_role_4: "Підтримка комунікацій фонду в Європі",
    // DAOS
    partner_daos_short: "Партнер у сфері охорони здоровʼя, спрямований на підтримку людей у збереженні фізичного та ментального благополуччя через доступні програми та комплексний догляд",
    partner_daos_full: "DAOS — партнер Фонду Graweo у сфері охорони здоровʼя, присвячений допомозі людям у збереженні фізичного та ментального здоровʼя. DAOS розробляє та впроваджує доступні програми, орієнтовані на комплексне благополуччя, підтримку психічного здоровʼя та фізичну реабілітацію. Разом з фондом DAOS працює над тим, щоб люди, яких торкнулися соціальні та гуманітарні виклики, мали доступ до якісної підтримки здоровʼя.",
    partner_daos_role: "Партнер з охорони здоровʼя та благополуччя",
    partner_daos_expertise_1: "Програми збереження фізичного здоровʼя та реабілітації",
    partner_daos_expertise_2: "Підтримка психічного здоровʼя та психологічного благополуччя",
    partner_daos_expertise_3: "Комплексні та профілактичні підходи до охорони здоровʼя",
    partner_daos_expertise_4: "Освіта у сфері здоровʼя та підвищення обізнаності громади",
    partner_daos_area_1: "Фізичне Здоровʼя",
    partner_daos_area_2: "Ментальне Здоровʼя",
    partner_daos_area_3: "Реабілітація",
    partner_daos_area_4: "Програми Благополуччя",
    partner_daos_role_1: "Програми збереження фізичного здоровʼя для бенефіціарів фонду",
    partner_daos_role_2: "Підтримка психічного здоровʼя та психологічна допомога",
    partner_daos_role_3: "Ініціативи комплексного благополуччя та освіта у сфері здоровʼя",
    partner_daos_role_4: "Підтримка реабілітації та відновлення постраждалих громад",

    partners_visit_website: "Відвідати Сайт",
    partners_join_title: "Станьте Партнером",
    partners_join_desc: "Вас цікавить приєднання до мережі партнерів Graweo? Ми вітаємо організації, які поділяють нашу візію підтримки сталого розвитку та розширення можливостей громади.",
    partners_contact_us: "Звяжіться з Нами",
    partners_benefits_title: "Переваги Партнерства",
    partnership_benefit_1_title: "Спільна Візія",
    partnership_benefit_1_desc: "Робота з організацією, привержена соціальному впливу та сталому розвитку",
    partnership_benefit_2_title: "Технічна Досконалість",
    partnership_benefit_2_desc: "Доступ до професійної експертизи та ресурсів у кількох секторах",
    partnership_benefit_3_title: "Стала Зростання",
    partnership_benefit_3_desc: "Побудова тривалих рішень з позитивним впливом на навколишнє середовище та суспільство",
    partnership_benefit_4_title: "Розширення Мережі",
    partnership_benefit_4_desc: "Зв'яжіться з однодумцями та розширте свій вплив",
    partners_values_title: "Цінності Партнерства",
    partners_value_1_title: "Чесність та Прозорість",
    partners_value_1_desc: "Ми працюємо з повною прозорістю та дотримуємо найвищих етичних стандартів у всіх партнерських відносинах та операціях.",
    partners_value_2_title: "Сталість",
    partners_value_2_desc: "Ми надаємо пріоритет довгострокові сталим рішенням замість швидких виправлень, забезпечуючи тривалий позитивний вплив.",
    partners_value_3_title: "Співпраця",
    partners_value_3_desc: "Ми вірим у силу партнерства та тісно співпрацюємо з нашими партнерами для досягнення спільних цілей.",
    partners_value_4_title: "Орієнтування на Вплив",
    partners_value_4_desc: "Кожне рішення керується нашою прихильністю до створення значущих, вимірюваних позитивних змін.",
    partners_cta_title: "Готові Разом Змінити Світ?",
    partners_cta_text: "Приєднайтеся до нашої мережі стратегічних партнерів та допоможіть нам трансформувати життя за допомогою сталого розвитку та підтримки громад.",
    partners_cta_button: "Дізнайтеся про Партнерство",
    learn_more: "Дізнатися більше",

    // 404 Page
    notfound_title: "Сторінка Не Знайдена",
    notfound_description: "Сторінка, яку ви шукаєте, не існує або була перенесена. Давайте повернемо вас на правильний шлях!",
    notfound_home: "На Головну",
    notfound_back: "Повернутися",
    notfound_help: "Потрібна допомога у пошуку?",
    notfound_contact: "Зв'яжіться з нами",

    footer_tagline: "Підтримка відновлення та возрождення",
    footer_links: "Швидкі Посилання",
    footer_contact: "Контактна Інформація",
    footer_rights: "Усі права захищено",
    footer_gdpr_link: "Політика конфіденційності та GDPR",

    gdpr_badge: "Відповідність GDPR",
    gdpr_title: "Політика конфіденційності та GDPR",
    gdpr_subtitle: "Як ми збираємо, використовуємо та захищаємо ваші персональні дані",
    gdpr_updated: "Оновлено: березень 2026",
    gdpr_intro_title: "Вступ",
    gdpr_intro_text: "Благодійний фонд Graweo зобов'язується захищати ваші персональні дані відповідно до Загального регламенту захисту даних (GDPR) (ЄС) 2016/679. Ця політика пояснює, які дані ми збираємо, як їх використовуємо та які права ви маєте як суб'єкт даних. Використовуючи наш сайт і послуги, ви підтверджуєте, що ознайомилися з цією політикою і надаєте згоду на обробку ваших персональних даних.",
    gdpr_data_title: "Які персональні дані ми збираємо",
    gdpr_data_text: "Ми можемо збирати такі категорії персональних даних: контактна інформація (ім'я, адреса електронної пошти) при заповненні форм або здійсненні пожертв; платіжна інформація, що безпечно обробляється через сертифікованих платіжних провайдерів (Stripe); дані використання та аналітика, що збираються автоматично при відвідуванні сайту (IP-адреса, тип браузера, відвідані сторінки); дані комунікацій при зверненні через електронну пошту або Telegram.",
    gdpr_purpose_title: "Правова основа та мета обробки",
    gdpr_purpose_text: "Ми обробляємо ваші персональні дані на таких правових підставах:\n\n(1) Згода — для підписки на розсилку та маркетингових комунікацій.\n\n(2) Необхідність виконання договору — для обробки пожертв та надання послуг.\n\n(3) Законні інтереси — для покращення сайту та послуг, а також запобігання шахрайству.\n\n(4) Юридичне зобов'язання — для дотримання чинного законодавства та нормативних вимог.",
    gdpr_rights_title: "Ваші права за GDPR",
    gdpr_rights_intro: "Як суб'єкт даних за GDPR, ви маєте такі права. Для їх реалізації зв'яжіться з нами за адресою info@graweo.org.",
    gdpr_right_access: "Право на доступ",
    gdpr_right_access_desc: "Ви маєте право вимагати копію ваших персональних даних, що ми зберігаємо, разом з інформацією про те, як вони використовуються.",
    gdpr_right_deletion: "Право на видалення",
    gdpr_right_deletion_desc: "Ви можете вимагати видалення ваших персональних даних, коли вони більше не потрібні для цілей, для яких були зібрані.",
    gdpr_right_portability: "Право на перенесення даних",
    gdpr_right_portability_desc: "Ви маєте право отримати ваші дані у структурованому, загальноприйнятому та машиночитаному форматі та передати їх іншому контролеру.",
    gdpr_right_objection: "Право на заперечення",
    gdpr_right_objection_desc: "Ви можете заперечити проти обробки ваших даних з метою прямого маркетингу або з причин, пов'язаних з вашою конкретною ситуацією.",
    gdpr_right_restriction: "Право на обмеження обробки",
    gdpr_right_restriction_desc: "Ви маєте право вимагати обмеження обробки ваших персональних даних за певних обставин.",
    gdpr_right_correction: "Право на виправлення",
    gdpr_right_correction_desc: "Ви маєте право вимагати виправлення неточних або неповних персональних даних, що ми зберігаємо.",
    gdpr_tech_title: "Технічна інфраструктура та безпека даних",
    gdpr_tech_text_before: "Наш сайт і цифрова інфраструктура розміщені та обслуговуються компанією",
    gdpr_tech_text_after: "— нашим технологічним партнером, що спеціалізується на безпечних хмарних середовищах, що відповідають вимогам GDPR. U-Cloud24 надає хмарну інфраструктуру, підтримку DevOps та послуги з безпеки даних, забезпечуючи зберігання та обробку всіх персональних даних відповідно до європейських стандартів захисту даних. U-Cloud24 виступає обробником даних за GDPR та дотримується стандартів безпеки ISO.",
    gdpr_tech_visit: "Дізнайтеся більше про технічні можливості U-Cloud24 на сайті",
    gdpr_cookies_title: "Файли cookie та аналітика",
    gdpr_cookies_text: "Наш сайт використовує файли cookie та Google Analytics (через Google Tag Manager) для аналізу взаємодії відвідувачів із контентом. Це включає функціональні файли cookie, необхідні для роботи сайту, та аналітичні файли cookie, що допомагають покращувати наші послуги. Аналітичні дані за можливості анонімізуються. Ви можете вимкнути необов'язкові файли cookie в налаштуваннях браузера.",
    gdpr_consent_title: "Ваша згода",
    gdpr_consent_text: "Використовуючи цей сайт, надсилаючи контактну форму або здійснюючи пожертву, ви підтверджуєте, що прочитали та зрозуміли цю Політику конфіденційності та GDPR і надаєте згоду на обробку ваших персональних даних. Ви маєте право відкликати свою згоду в будь-який момент, зв'язавшись з нами.",
    gdpr_contact_title: "Контакт з питань даних",
    gdpr_contact_text: "Для реалізації будь-якого з ваших прав за GDPR або при наявності питань щодо обробки персональних даних зверніться до нашого спеціаліста із захисту даних:",
    gdpr_contact_form_link: "Використати форму зворотного зв'язку",
  },

  de: {
    nav_home: "Startseite",
    nav_about: "Über uns",
    nav_business: "Geschäftsunterstützung",
    nav_programs: "Programme",
    nav_partners: "Partner",
    nav_donate: "Spenden",
    nav_reports: "Berichte",
    nav_contacts: "Kontakt",

    hero_title: "Hoffnung durch Unterstützung schaffen",
    hero_subtitle: "Wohltätigkeitsstiftung Graweo",
    hero_description: "Wir schaffen Bedingungen, unter denen Menschen, die schwierige Umstände erlebt haben, ihr Leben, ihre Arbeit und ihre Würde wiederherstellen können",
    hero_cta: "Jetzt Spenden",

    about_title: "Über die Stiftung",
    about_description: "Graweo ist eine Wohltätigkeitsstiftung, die sich der Unterstützung von Menschen im Wiederaufbauprozess nach Schwierigkeiten widmet. Wir konzentrieren uns auf Unterstützung zur Wiederaufbau, Reintegration und Wiederherstellung von Lebensgrundlagen.",

    directions_title: "Hilfsbereiche",
    direction_humanitarian: "Notwendige Unterstützung",
    direction_humanitarian_desc: "Ressourcen, Hilfe und Notwendiges für den Wiederaufbau",
    direction_idps: "Reintegration",
    direction_idps_desc: "Gesellschaftliche Integration, Rechtsbeistand",
    direction_business: "Wiederherstellung der Lebensgrundlagen",
    direction_business_desc: "Schulung, Unternehmensunterstützung, Beschäftigungshilfe",

    howwework_title: "Wie Wir Arbeiten",
    howwework_step1: "Bedürfnisse verstehen",
    howwework_step1_desc: "Wir analysieren Situationen und bewerten individuelle Umstände",
    howwework_step2: "Ressourcen mobilisieren",
    howwework_step2_desc: "Wir werben Unterstützung an und finden Partner",
    howwework_step3: "Hilfe leisten",
    howwework_step3_desc: "Wir leisten maßgeschneiderte Hilfe für diejenigen, die sie benötigen",
    howwework_step4: "Bericht und Lernen",
    howwework_step4_desc: "Volle Transparenz und kontinuierliche Verbesserung",

    latest_reports: "Neueste Berichte",
    view_report: "Bericht Ansehen",
    all_reports: "Alle Berichte",
    video_title: "Graweo in Aktion",

    mission_title: "Unsere Mission",
    mission_text: "Unsere Mission ist es, Bedingungen zu schaffen, unter denen Menschen, die schwierige Umstände erlebt haben, ihr Leben, ihre Arbeit und ihre Würde wiederherstellen können. Wir arbeiten grenzenlos und helfen dort, wo Unterstützung am dringendsten benötigt wird, und stärken die Hoffnung auf eine nachhaltige Zukunft.",

    goals_title: "Unsere Ziele",
    goal1: "Notwendige Unterstützung für Menschen in gefährdeten Situationen leisten",
    goal2: "Erfolgreiche Reintegration ermöglichen",
    goal3: "Wiederherstellung der Lebensgrundlagen und wirtschaftlicher Unabhängigkeit unterstützen",
    goal4: "Volle Transparenz bei allen Operationen",

    legal_title: "Rechtliche Informationen",
    legal_name: "Name:",
    legal_name_value: "Wohltätigkeitsstiftung GRAWEO",
    legal_registration: "Registrierung:",
    legal_country: "Land:",
    legal_address: "Adresse:",
    legal_country_value: "Ukraine",
    legal_address_value: "Charkiw, Ukraine",

    requisites_title: "Bankverbindung",
    requisites_ukraine: "Ukraine",
    requisites_poland: "Polen",
    requisites_account: "Konto:",
    requisites_bank: "Bank:",
    requisites_swift: "SWIFT:",
    requisites_iban: "IBAN:",

    donate_title: "Unterstützen Sie Unsere Mission",
    donate_subtitle: "Ihr Beitrag hilft uns, wichtige Hilfe zu leisten",

    crypto_title: "Kryptowährungsspenden",
    crypto_subtitle: "Sofort und sicher",
    copy_address: "Adresse Kopieren",
    address_copied: "Adresse kopiert!",

    bank_title: "Banküberweisung",
    card_coming_soon: "Demnächst — Bankverbindungsdetails werden in Kürze verfügbar sein.",
    bank_ukraine: "Ukraine (UAH)",
    bank_poland: "Polen (PLN/EUR)",

    card_title: "Kartenzahlung",
    card_button: "Per Karte Spenden",
    card_description: "Schnelle und sichere Zahlung mit Kredit- oder Debitkarte über Stripe",

    currency_select_title: "Spendenwährung auswählen",
    currency_select_subtitle: "Wählen Sie die Währung, in der Sie spenden möchten",
    currency_donate_button: "Spenden",
    currency_stripe_note: "Sie werden auf eine sichere Stripe-Zahlungsseite weitergeleitet",

    purpose_title: "Zweck der Spende",
    purpose_humanitarian: "Notwendige Unterstützung",
    purpose_idps: "Reintegration",
    purpose_business: "Wiederherstellung der Lebensgrundlagen",
    purpose_other: "Andere",

    reports_title: "Unsere Berichte",
    reports_subtitle: "Transparenz bei jedem Schritt",
    date: "Datum",
    read_more: "Mehr Lesen",

    back_to_reports: "Zurück zu Berichten",
    gallery_title: "Fotogalerie",

    contacts_title: "Kontaktieren Sie Uns",
    contacts_subtitle: "Wir sind hier, um Ihre Fragen zu beantworten",

    contact_email: "Email",
    contact_telegram: "Telegram",
    contact_form_title: "Nachricht Senden",

    form_name: "Ihr Name",
    form_email: "Ihre Email",
    form_message: "Nachricht",
    form_submit: "Nachricht Senden",
    form_success: "Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.",

    // Business Support page
    business_hero_subtitle: "Unterstützung von Unternehmern beim Wiederaufbau und der Expansion ihrer Unternehmen",
    business_apply_now: "Jetzt Bewerben",
    business_overview_title: "Erfolg Gemeinsam Aufbauen",
    business_overview_text: "Unser Geschäftsunterstützungsprogramm bietet umfassende Unterstützung für Unternehmer, die ihre Lebensgrundlagen wieder aufbauen. Wir bieten Schulung, Mentoring, Netzwerkmöglichkeiten und finanzielle Unterstützung, um Ihnen beim Start oder bei der Expansion Ihres Unternehmens zu helfen.",
    business_benefit_1: "Professionelle Geschäftsschulung und Kompetenzentwicklung",
    business_benefit_2: "Eins-zu-eins-Mentoring von erfahrenen Unternehmern",
    business_benefit_3: "Zugang zu Finanzressourcen und Mikrokreditprogrammen",
    business_programs_title: "Unsere Unterstützungsprogramme",
    business_program_training: "Geschäftsschulung",
    business_program_training_desc: "Umfassende Kurse zu Geschäftsplanung, Marketing, Finanzmanagement und operativer Exzellenz.",
    business_program_mentorship: "Mentoring & Coaching",
    business_program_mentorship_desc: "Persönliche Anleitung von erfahrenen Unternehmern, um Sie bei der Überwindung von Herausforderungen und der Beschleunigung des Wachstums zu unterstützen.",
    business_program_networking: "Geschäftsnetzwerk",
    business_program_networking_desc: "Verbinden Sie sich mit anderen Unternehmern, potenziellen Partnern und Investoren in unserer Gemeinschaft.",
    business_program_funding: "Finanzielle Unterstützung",
    business_program_funding_desc: "Zugang zu Zuschüssen, Mikrokrediten und Investitionsmöglichkeiten zur Finanzierung Ihrer Geschäftsvorhaben.",
    business_process_title: "Unser 4-Stufen-Prozess",
    business_step_assessment: "Bewertung",
    business_step_assessment_desc: "Wir bewerten Ihre Geschäftsidee und aktuelle Situation.",
    business_step_planning: "Planung",
    business_step_planning_desc: "Entwickeln Sie einen umfassenden Geschäfts- und Finanzplan.",
    business_step_implementation: "Implementierung",
    business_step_implementation_desc: "Erhalten Sie Unterstützung beim Start oder der Skalierung Ihres Unternehmens.",
    business_step_monitoring: "Überwachung",
    business_step_monitoring_desc: "Kontinuierliche Unterstützung und Leitlinien, während Ihr Unternehmen wächst.",
    business_eligibility_title: "Wer Kann Sich Bewerben?",
    business_eligibility_1: "Mindestens 18 Jahre alt mit einer rentablen Geschäftsidee",
    business_eligibility_2: "Zeigen Sie Engagement für Unternehmertum und Wachstum",
    business_eligibility_3: "Bereitschaft zur Zusammenarbeit mit Mentoren und zum Absolvieren von Schulungen",
    business_eligibility_4: "Zeigen Sie Potenzial zur Schaffung von Arbeitsplätzen",
    business_cta_title: "Bereit, Ihre Reise zu Beginnen?",
    business_cta_text: "Treten Sie unserem Geschäftsunterstützungsprogramm bei und verbinden Sie sich mit Mentoren, Investoren und anderen Unternehmern, die Ihnen zum Erfolg verhelfen können.",

    // Programs page
    programs_title: "Unsere Unterstützungsprogramme",
    programs_subtitle: "Umfassende Programme zur Unterstützung bei der Wiederaufbau und zum Erfolg",
    programs_available: "Verfügbare Programme",
    program_training_title: "Geschäftsschulung und Kompetenzentwicklung",
    program_training_short: "Professionelle Kurse zur Erweiterung von Geschäftskenntnissen",
    program_training_full: "Umfassende Geschäftskurse, die wichtige Themen wie Geschäftsplanung, digitales Marketing, Finanzmanagement und betriebliche Exzellenz abdecken. Unser Curriculum wurde von Branchenexperten entwickelt und ist auf Ihre Bedürfnisse zugeschnitten.",
    program_training_benefit_1: "Praktische Schulungsworkshops",
    program_training_benefit_2: "Zertifikat nach erfolgreichem Abschluss",
    program_training_benefit_3: "Zugang zu Lernmaterialien und Ressourcen",
    program_training_benefit_4: "Networking mit anderen Teilnehmern",
    program_training_duration: "3-6 Monate",
    program_training_cost: "Kostenlos",
    program_mentorship_title: "Mentoring- und Coachingprogramm",
    program_mentorship_short: "Eins-zu-eins-Beratung von erfahrenen Unternehmern",
    program_mentorship_full: "Erhalten Sie persönliche Beratung von erfolgreichen Unternehmern, die den Weg bereits gegangen sind. Unsere Mentoren bieten strategische Beratung, helfen bei der Überwindung von Herausforderungen und beschleunigen das Geschäftswachstum.",
    program_mentorship_benefit_1: "Eins-zu-eins-Mentoring-Sitzungen",
    program_mentorship_benefit_2: "Personalisierte Geschäftsstrategie",
    program_mentorship_benefit_3: "Regelmäßige Fortschrittsüberprüfungen",
    program_mentorship_benefit_4: "Zugang zu Mentor-Netzwerk",
    program_mentorship_duration: "6-12 Monate",
    program_mentorship_cost: "Kostenlos",
    program_networking_title: "Geschäfts-Networking-Events",
    program_networking_short: "Treffen Sie Unternehmer, Partner und Investoren",
    program_networking_full: "Nehmen Sie an unseren Gemeinschaftsveranstaltungen teil, wo Sie andere Unternehmer, potenzielle Partner, Investoren und Dienstleister treffen können. Bauen Sie wertvolle Beziehungen auf, die Ihrem Geschäft helfen zu wachsen.",
    program_networking_benefit_1: "Monatliche Networking-Events",
    program_networking_benefit_2: "Zugang zu Investor-Pitch-Möglichkeiten",
    program_networking_benefit_3: "Partnerschafts- und Kooperationsmöglichkeiten",
    program_networking_benefit_4: "Online-Community-Plattform",
    program_networking_duration: "Laufend",
    program_networking_cost: "Kostenlos",
    program_grants_title: "Zuschuss- und Finanzierungsprogramme",
    program_grants_short: "Zugang zu Finanzressourcen und Mikrokrediten",
    program_grants_full: "Wir bieten Zuschüsse, Mikrokredite und verbinden Sie mit Investoren. Unsere Finanzierungsprogramme sollen Unternehmen in verschiedenen Entwicklungsstadien unterstützen.",
    program_grants_benefit_1: "Zuschüsse bis 5.000 EUR",
    program_grants_benefit_2: "Mikrokredite zu günstigen Bedingungen",
    program_grants_benefit_3: "Investitionsabstimmungsdienste",
    program_grants_benefit_4: "Finanzplanungshilfe",
    program_grants_duration: "3-4 Monate Genehmigung",
    program_grants_cost: "Kostenlose Bewerbung",
    program_accelerator_title: "Business-Accelerator-Programm",
    program_accelerator_short: "Intensives Programm zum schnellen Skalieren Ihres Geschäfts",
    program_accelerator_full: "Unser 6-Monats-Accelerator-Programm kombiniert Mentoring, Schulung und Finanzierung, um vielversprechenden Unternehmen zu helfen, zu skalieren. Erhalten Sie Zugang zu Expertennberaten, Ressourcen und Investitionsmöglichkeiten.",
    program_accelerator_benefit_1: "Intensives 6-Monats-Programm",
    program_accelerator_benefit_2: "Finanzierungsmöglichkeiten bis 25.000 EUR",
    program_accelerator_benefit_3: "Beirat von Experten",
    program_accelerator_benefit_4: "Demo Day und Investor Pitching",
    program_accelerator_duration: "6 Monate intensiv",
    program_accelerator_cost: "Variabler Eigenkapital",
    program_about: "Über dieses Programm",
    program_benefits: "Hauptvorteile",
    program_duration: "Programmdauer",
    program_cost: "Kosten",
    program_apply: "Jetzt Bewerben",
    programs_why_choose: "Warum Unsere Programme Wählen",
    programs_feature_1_title: "Von Experten Geleitete Programme",
    programs_feature_1_desc: "Alle Programme werden von Branchenexperten mit jahrelanger Erfahrung entworfen und geleitet",
    programs_feature_2_title: "Personalisierte Unterstützung",
    programs_feature_2_desc: "Wir passen unsere Programme Ihren spezifischen Bedürfnissen und Zielen an",
    programs_feature_3_title: "Gemeinschaftsorientiert",
    programs_feature_3_desc: "Seien Sie Teil einer unterstützenden Gemeinschaft von Unternehmern und Innovatoren",
    programs_how_apply: "Wie man sich bewirbt",
    programs_apply_step_1_title: "Reichen Sie Ihre Bewerbung ein",
    programs_apply_step_1_desc: "Füllen Sie unser Online-Bewerbungsformular mit Details zu Ihrem Geschäft und Ihren Zielen aus",
    programs_apply_step_2_title: "Erste Bewertung",
    programs_apply_step_2_desc: "Unser Team überprüft Ihre Bewerbung und führt eine erste Bewertung durch",
    programs_apply_step_3_title: "Interview und Genehmigung",
    programs_apply_step_3_desc: "Ausgewählte Kandidaten werden zu einem Interview mit unserem Bewertungsteam eingeladen",
    programs_apply_step_4_title: "Programmanmeldung",
    programs_apply_step_4_desc: "Nach der Genehmigung erhalten Sie Anmeldungsdetails und starten Ihre Programmreise",
    programs_cta_title: "Bereit, Ihr Geschäft zu transformieren?",
    programs_cta_text: "Wählen Sie das Programm, das am besten zu Ihren Bedürfnissen passt, und machen Sie den ersten Schritt zum Aufbau eines erfolgreichen, nachhaltigen Geschäfts.",
    programs_cta_button: "Programme Erkunden",

    // Partners page
    partners_title: "Unsere Partner",
    partners_subtitle: "Strategische Partnerschaften, die unsere Mission stärken und unseren Einfluss erweitern",
    partners_our_partners: "Unsere Strategischen Partner",
    partners_expertise: "Fachwissen",
    partners_areas: "Tätigkeitsbereiche",
    partners_role_ecosystem: "Rolle im Graweo-Ökosystem",

    // U-Cloud24
    partner_ucloud_short: "Technologiepartner, der Cloud-Infrastruktur, DevOps-Unterstützung und AI-Lösungen bereitstellt",
    partner_ucloud_full: "U-Cloud24 ist ein Technologiepartner der Graweo-Stiftung und bietet Cloud-Infrastruktur, DevOps-Unterstützung und AI-Lösungen für durch Zuschüsse und Unternehmensprogramme finanzierte Projekte. Das Unternehmen hilft Organisationen, sichere, skalierbare und europäischen Anforderungen entsprechende digitale Umgebungen aufzubauen. U-Cloud24 spezialisiert sich auf moderne Cloud-Technologien, automatisierte Bereitstellungen, Datenanalysetools und die Gewährleistung der Einhaltung von GDPR- und ISO-Standards.",
    partner_ucloud_role: "Technologie- und Infrastrukturpartner",
    partner_ucloud_expertise_cloud: "Cloud-Infrastruktur und DevOps-Services",
    partner_ucloud_expertise_ai: "AI-gestützte Lösungen und Automatisierungstools",
    partner_ucloud_expertise_security: "Datensicherheit und Analysefähigkeiten",
    partner_ucloud_expertise_compliance: "Fachwissen zu GDPR- und ISO-Compliance",
    partner_ucloud_area_cloud: "Cloud-Infrastruktur",
    partner_ucloud_area_devops: "DevOps-Dienstleistungen",
    partner_ucloud_area_ai: "AI & Automatisierung",
    partner_ucloud_area_security: "Datensicherheit & Compliance",
    partner_ucloud_role_1: "Infrastruktur für Forschungs- und Innovationsprojekte",
    partner_ucloud_role_2: "DevOps-Unterstützung für durch Zuschüsse finanzierte Teams",
    partner_ucloud_role_3: "AI-Tools für Datenanalyse und Automatisierung",
    partner_ucloud_role_4: "Sicherheits- und Compliance-Gewährleistung (GDPR, ISO)",

    // Craft-Me
    partner_craftme_short: "Kreativpartner, spezialisiert auf Videoproduktion, visuelles Storytelling und Content-Erstellung für soziale und kulturelle Initiativen",
    partner_craftme_full: "Craft-Me ist ein Kreativpartner der Graweo-Stiftung und spezialisiert sich auf Videoproduktion, visuelles Storytelling und Content-Erstellung für soziale, bildungs- und kulturelle Initiativen. Das Team von Craft-Me hilft der Stiftung, überzeugende Geschichten zu erzählen, Aufmerksamkeit auf wichtige Themen zu lenken und die Auswirkungen von Projekten durch professionelle Video- und visuelle Inhalte zu verstärken.",
    partner_craftme_role: "Kreativer und Content-Partner",
    partner_craftme_expertise_video: "Professionelle Videoproduktion und dokumentarisches Storytelling",
    partner_craftme_expertise_visual: "Erstellung von visuellen Inhalten und Design für digitale Plattformen",
    partner_craftme_expertise_campaigns: "Kampagnen in sozialen Medien und digitales Marketing",
    partner_craftme_expertise_communication: "Unterstützung europäischer Kommunikation und mehrsprachige Inhalte",
    partner_craftme_area_video: "Videoproduktion",
    partner_craftme_area_content: "Content-Erstellung",
    partner_craftme_area_social: "Soziale Medien",
    partner_craftme_area_creative: "Kreative Kampagnen",
    partner_craftme_role_1: "Produktion von Dokumentar- und Sozialvideos",
    partner_craftme_role_2: "Erstellung von Visualmaterialien für Zuschussanträge",
    partner_craftme_role_3: "Entwicklung und Umsetzung kreativer Kampagnen",
    partner_craftme_role_4: "Unterstützung der Stiftungskommunikation in Europa",
    // DAOS
    partner_daos_short: "Gesundheitspartner, der Menschen dabei unterstützt, ihre körperliche und geistige Gesundheit durch zugängliche Programme und ganzheitliche Fürsorge zu erhalten",
    partner_daos_full: "DAOS ist ein Gesundheitspartner der Graweo-Stiftung, der sich der Unterstützung von Menschen beim Erhalt ihrer körperlichen und geistigen Gesundheit widmet. DAOS entwickelt und implementiert zugängliche Programme mit Fokus auf ganzheitliches Wohlbefinden, psychische Gesundheitsunterstützung und körperliche Rehabilitation. Gemeinsam mit der Stiftung arbeitet DAOS daran, dass Menschen, die von sozialen und humanitären Herausforderungen betroffen sind, Zugang zu qualitativ hochwertiger Gesundheitsversorgung erhalten.",
    partner_daos_role: "Gesundheits- und Wohlbefindenpartner",
    partner_daos_expertise_1: "Programme zur Erhaltung der körperlichen Gesundheit und Rehabilitation",
    partner_daos_expertise_2: "Unterstützung der psychischen Gesundheit und des psychologischen Wohlbefindens",
    partner_daos_expertise_3: "Ganzheitliche und präventive Ansätze zur Gesundheitsversorgung",
    partner_daos_expertise_4: "Gesundheitsaufklärung und Sensibilisierung der Gemeinschaft",
    partner_daos_area_1: "Körperliche Gesundheit",
    partner_daos_area_2: "Psychische Gesundheit",
    partner_daos_area_3: "Rehabilitation",
    partner_daos_area_4: "Wohlbefindensprogramme",
    partner_daos_role_1: "Programme zur Erhaltung der körperlichen Gesundheit für Stiftungsbegünstigte",
    partner_daos_role_2: "Psychische Gesundheitsunterstützung und psychologische Hilfe",
    partner_daos_role_3: "Ganzheitliche Wohlbefindensinitiativen und Gesundheitsaufklärung",
    partner_daos_role_4: "Rehabilitations- und Genesungsunterstützung für betroffene Gemeinschaften",

    partners_visit_website: "Website Besuchen",
    partners_join_title: "Werden Sie Partner",
    partners_join_desc: "Sind Sie daran interessiert, dem Graweo-Partnernetzwerk beizutreten? Wir heißen Organisationen willkommen, die unsere Vision der Unterstützung nachhaltiger Entwicklung und Gemeindeförderung teilen.",
    partners_contact_us: "Kontaktieren Sie Uns",
    partners_benefits_title: "Vorteile der Partnerschaft",
    partnership_benefit_1_title: "Gemeinsame Vision",
    partnership_benefit_1_desc: "Zusammenarbeit mit einer Organisation, die sich sozialen Auswirkungen und nachhaltiger Entwicklung verschrieben hat",
    partnership_benefit_2_title: "Technische Exzellenz",
    partnership_benefit_2_desc: "Zugang zu professionellem Fachwissen und Ressourcen in mehreren Sektoren",
    partnership_benefit_3_title: "Nachhaltige Entwicklung",
    partnership_benefit_3_desc: "Aufbau von Langzeitlösungen mit positiven Auswirkungen auf Umwelt und Gesellschaft",
    partnership_benefit_4_title: "Netzwerkerweiterung",
    partnership_benefit_4_desc: "Verbinden Sie sich mit gleichgesinnten Organisationen und erweitern Sie Ihren Einfluss",
    partners_values_title: "Partnerschafswerte",
    partners_value_1_title: "Integrität und Transparenz",
    partners_value_1_desc: "Wir arbeiten mit vollständiger Transparenz und halten die höchsten ethischen Standards in allen Partnerschaften und Operationen ein.",
    partners_value_2_title: "Nachhaltigkeit",
    partners_value_2_desc: "Wir priorisieren langfristige nachhaltige Lösungen gegenüber Schnellkorrekturen und gewährleisten langfristige positive Auswirkungen.",
    partners_value_3_title: "Zusammenarbeit",
    partners_value_3_desc: "Wir glauben an die Kraft der Partnerschaft und arbeiten eng mit unseren Partnern zusammen, um gemeinsame Ziele zu erreichen.",
    partners_value_4_title: "Auswirkungsorientiert",
    partners_value_4_desc: "Jede Entscheidung wird von unserem Engagement für bedeutungsvolle, messbare positive Veränderungen geleitet.",
    partners_cta_title: "Bereit, die Welt Gemeinsam zu Verändern?",
    partners_cta_text: "Treten Sie unserem Netzwerk strategischer Partner bei und helfen Sie uns, Leben durch nachhaltige Entwicklung und Unterstützung der Gemeinschaft zu transformieren.",
    partners_cta_button: "Partnership Erkunden",
    learn_more: "Mehr erfahren",

    // 404 Page
    notfound_title: "Seite Nicht Gefunden",
    notfound_description: "Die Seite, die Sie suchen, existiert nicht oder wurde verschoben. Lassen Sie uns Sie auf den richtigen Weg bringen!",
    notfound_home: "Zur Startseite",
    notfound_back: "Zurück",
    notfound_help: "Benötigen Sie Hilfe bei der Suche?",
    notfound_contact: "Kontaktieren Sie uns",

    footer_tagline: "Unterstützung für Wiederaufbau und Erneuerung",
    footer_links: "Schnelllinks",
    footer_contact: "Kontaktinformationen",
    footer_rights: "Alle Rechte vorbehalten",
    footer_gdpr_link: "Datenschutz & DSGVO",

    gdpr_badge: "DSGVO-Konformität",
    gdpr_title: "Datenschutz & DSGVO-Richtlinie",
    gdpr_subtitle: "Wie wir Ihre persönlichen Daten erheben, verwenden und schützen",
    gdpr_updated: "Zuletzt aktualisiert: März 2026",
    gdpr_intro_title: "Einleitung",
    gdpr_intro_text: "Die Graweo Charitable Foundation verpflichtet sich zum Schutz Ihrer personenbezogenen Daten gemäß der Datenschutz-Grundverordnung (DSGVO) (EU) 2016/679. Diese Richtlinie erklärt, welche Daten wir erheben, wie wir sie verwenden und welche Rechte Sie als betroffene Person haben. Durch die Nutzung unserer Website und Dienste bestätigen Sie, dass Sie diese Richtlinie gelesen haben und der Verarbeitung Ihrer personenbezogenen Daten zustimmen.",
    gdpr_data_title: "Welche personenbezogenen Daten wir erheben",
    gdpr_data_text: "Wir können folgende Kategorien personenbezogener Daten erheben: Kontaktinformationen (Name, E-Mail-Adresse) bei der Übermittlung von Formularen oder Spenden; Zahlungsinformationen, die sicher über zertifizierte Zahlungsanbieter (Stripe) verarbeitet werden; Nutzungs- und Analysedaten, die automatisch beim Besuch unserer Website gesammelt werden (IP-Adresse, Browsertyp, besuchte Seiten); Kommunikationsdaten bei der Kontaktaufnahme per E-Mail oder Telegram.",
    gdpr_purpose_title: "Rechtsgrundlage und Zweck der Verarbeitung",
    gdpr_purpose_text: "Wir verarbeiten Ihre personenbezogenen Daten auf folgenden Rechtsgrundlagen:\n\n(1) Einwilligung — für Newsletter-Abonnements und Marketingkommunikation.\n\n(2) Vertragliche Notwendigkeit — zur Verarbeitung von Spenden und Erbringung von Dienstleistungen.\n\n(3) Berechtigte Interessen — zur Verbesserung unserer Website und Dienste sowie zur Betrugsprävention.\n\n(4) Rechtliche Verpflichtung — zur Einhaltung geltender Gesetze und Vorschriften.",
    gdpr_rights_title: "Ihre Rechte gemäß DSGVO",
    gdpr_rights_intro: "Als betroffene Person gemäß DSGVO stehen Ihnen folgende Rechte zu. Um diese auszuüben, kontaktieren Sie uns bitte unter info@graweo.org.",
    gdpr_right_access: "Auskunftsrecht",
    gdpr_right_access_desc: "Sie haben das Recht, eine Kopie der von uns gespeicherten personenbezogenen Daten sowie Informationen über deren Verwendung anzufordern.",
    gdpr_right_deletion: "Recht auf Löschung",
    gdpr_right_deletion_desc: "Sie können die Löschung Ihrer personenbezogenen Daten verlangen, wenn diese für die Zwecke, für die sie erhoben wurden, nicht mehr erforderlich sind.",
    gdpr_right_portability: "Recht auf Datenübertragbarkeit",
    gdpr_right_portability_desc: "Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten und an einen anderen Verantwortlichen zu übertragen.",
    gdpr_right_objection: "Widerspruchsrecht",
    gdpr_right_objection_desc: "Sie können der Verarbeitung Ihrer Daten für Direktmarketingzwecke oder aus Gründen, die sich aus Ihrer besonderen Situation ergeben, widersprechen.",
    gdpr_right_restriction: "Recht auf Einschränkung der Verarbeitung",
    gdpr_right_restriction_desc: "Sie haben das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.",
    gdpr_right_correction: "Recht auf Berichtigung",
    gdpr_right_correction_desc: "Sie haben das Recht, die Berichtigung unrichtiger oder unvollständiger personenbezogener Daten zu verlangen.",
    gdpr_tech_title: "Technische Infrastruktur & Datensicherheit",
    gdpr_tech_text_before: "Unsere Website und digitale Infrastruktur werden von",
    gdpr_tech_text_after: "gehostet und gewartet — unserem Technologiepartner, der auf sichere, DSGVO-konforme Cloud-Umgebungen spezialisiert ist. U-Cloud24 stellt Cloud-Infrastruktur, DevOps-Support und Datensicherheitsdienste bereit, die gewährleisten, dass alle personenbezogenen Daten gemäß europäischen Datenschutzstandards gespeichert und verarbeitet werden. U-Cloud24 fungiert als Auftragsverarbeiter gemäß DSGVO und erfüllt ISO-Sicherheitsstandards.",
    gdpr_tech_visit: "Mehr über die technischen Möglichkeiten von U-Cloud24 erfahren Sie unter",
    gdpr_cookies_title: "Cookies und Analysen",
    gdpr_cookies_text: "Unsere Website verwendet Cookies und Google Analytics (über Google Tag Manager), um zu verstehen, wie Besucher mit unseren Inhalten interagieren. Dies umfasst technisch notwendige Cookies sowie Analyse-Cookies zur Verbesserung unserer Dienste. Analysedaten werden soweit möglich anonymisiert. Sie können nicht wesentliche Cookies in Ihren Browsereinstellungen deaktivieren.",
    gdpr_consent_title: "Ihre Einwilligung",
    gdpr_consent_text: "Durch die Nutzung dieser Website, das Absenden eines Kontaktformulars oder das Tätigen einer Spende bestätigen Sie, dass Sie diese Datenschutz- und DSGVO-Richtlinie gelesen und verstanden haben und der Verarbeitung Ihrer personenbezogenen Daten zustimmen. Sie haben das Recht, Ihre Einwilligung jederzeit zu widerrufen, indem Sie uns kontaktieren.",
    gdpr_contact_title: "Kontakt für Datenanfragen",
    gdpr_contact_text: "Um Ihre DSGVO-Rechte auszuüben oder bei Fragen zur Verarbeitung Ihrer personenbezogenen Daten wenden Sie sich bitte an unseren Datenschutzbeauftragten:",
    gdpr_contact_form_link: "Kontaktformular verwenden",
  },

  // Translations for French
  fr: {
    nav_home: "Accueil",
    nav_about: "À Propos",
    nav_business: "Soutien Commercial",
    nav_programs: "Programmes",
    nav_partners: "Partenaires",
    nav_donate: "Donner",
    nav_reports: "Rapports",
    nav_contacts: "Contacts",

    hero_title: "Créer l'Espoir par le Soutien",
    hero_subtitle: "Fondation Caritative Graweo",
    hero_description: "Nous créons les conditions pour que les personnes ayant vécu des circonstances difficiles puissent reconstruire leur vie, leur travail et leur dignité",
    hero_cta: "Donner Maintenant",

    about_title: "À Propos de la Fondation",
    about_description: "Graweo est une fondation caritative dédiée à aider les gens à se reconstruire après des difficultés. Nous nous concentrons sur le soutien à la récupération, à la réintégration et à la restauration des moyens de subsistance.",

    directions_title: "Domaines d'Assistance",
    direction_humanitarian: "Soutien Essentiel",
    direction_humanitarian_desc: "Ressources, assistance et nécessités pour la récupération",
    direction_idps: "Réintégration",
    direction_idps_desc: "Intégration communautaire, soutien juridique",
    direction_business: "Restauration des Moyens de Subsistance",
    direction_business_desc: "Formation aux compétences, soutien commercial, aide à l'emploi",

    howwework_title: "Comment Nous Travaillons",
    howwework_step1: "Comprendre les Besoins",
    howwework_step1_desc: "Nous analysons les situations et évaluons les circonstances individuelles",
    howwework_step2: "Mobiliser les Ressources",
    howwework_step2_desc: "Nous attirons le soutien et trouvons des partenaires",
    howwework_step3: "Fournir du Soutien",
    howwework_step3_desc: "Nous fournissons une assistance adaptée à ceux qui en ont besoin",
    howwework_step4: "Rapporter et Apprendre",
    howwework_step4_desc: "Transparence totale et amélioration continue",

    latest_reports: "Derniers Rapports",
    view_report: "Voir le Rapport",
    all_reports: "Tous les Rapports",
    video_title: "Graweo en Action",

    donate_title: "Soutenez Notre Mission",
    donate_subtitle: "Votre contribution nous aide à fournir une aide essentielle à ceux qui en ont besoin",

    crypto_title: "Dons de Crypto-Monnaie",
    crypto_subtitle: "Instant et sécurisé",
    copy_address: "Copier l'Adresse",
    address_copied: "Adresse copiée!",

    bank_title: "Virement Bancaire",
    card_coming_soon: "Bientôt disponible — les coordonnées bancaires seront disponibles prochainement.",
    bank_ukraine: "Ukraine (UAH)",
    bank_poland: "Pologne (PLN/EUR)",

    card_title: "Paiement par Carte",
    card_button: "Donner par Carte",
    card_description: "Paiement rapide et sécurisé par carte de crédit ou débit via Stripe",

    currency_select_title: "Choisissez la devise du don",
    currency_select_subtitle: "Sélectionnez la devise dans laquelle vous souhaitez faire un don",
    currency_donate_button: "Faire un don",
    currency_stripe_note: "Vous serez redirigé vers une page de paiement sécurisée Stripe",

    purpose_title: "Objectif du Don",
    purpose_humanitarian: "Soutien Essentiel",
    purpose_idps: "Réintégration",
    purpose_business: "Restauration des Moyens de Subsistance",
    purpose_other: "Autre",

    reports_title: "Nos Rapports",
    reports_subtitle: "Transparence à chaque étape",
    date: "Date",
    read_more: "Lire la Suite",

    back_to_reports: "Retour aux Rapports",
    gallery_title: "Galerie de Photos",

    contacts_title: "Nous Contacter",
    contacts_subtitle: "Nous sommes là pour répondre à vos questions",

    contact_email: "Email",
    contact_telegram: "Telegram",
    contact_form_title: "Envoyer un Message",

    form_name: "Votre Nom",
    form_email: "Votre Email",
    form_message: "Message",
    form_submit: "Envoyer le Message",
    form_success: "Merci! Votre message a été envoyé avec succès.",

    business_hero_subtitle: "Soutenir les entrepreneurs à reconstruire et à développer leurs entreprises",
    business_apply_now: "Postuler Maintenant",
    business_overview_title: "Construire le Succès Ensemble",
    business_overview_text: "Notre Programme de Soutien Commercial offre une assistance complète aux entrepreneurs qui reconstruisent leurs moyens de subsistance. Nous proposons une formation, un mentorat, des opportunités de réseautage et un soutien financier pour vous aider à lancer ou à développer votre entreprise.",
    business_benefit_1: "Formation professionnelle aux affaires et développement des compétences",
    business_benefit_2: "Mentorat individuel de la part d'entrepreneurs expérimentés",
    business_benefit_3: "Accès aux ressources financières et aux programmes de microcrédit",
    business_programs_title: "Nos Programmes de Soutien",
    business_program_training: "Formation Commerciale",
    business_program_training_desc: "Cours complets couvrant la planification commerciale, le marketing, la gestion financière et l'excellence opérationnelle.",
    business_program_mentorship: "Mentorat et Coaching",
    business_program_mentorship_desc: "Conseils personnalisés de la part d'entrepreneurs expérimentés pour vous aider à surmonter les défis et à accélérer la croissance.",
    business_program_networking: "Réseautage Commercial",
    business_program_networking_desc: "Connectez-vous avec d'autres entrepreneurs, partenaires potentiels et investisseurs dans notre communauté.",
    business_program_funding: "Soutien Financier",
    business_program_funding_desc: "Accès aux subventions, aux microcrédits et aux opportunités d'investissement pour financer vos entreprises.",
    business_process_title: "Notre Processus en 4 Étapes",
    business_step_assessment: "Évaluation",
    business_step_assessment_desc: "Nous évaluons votre idée commerciale et votre situation actuelle.",
    business_step_planning: "Planification",
    business_step_planning_desc: "Élaborez un plan commercial et financier global.",
    business_step_implementation: "Mise en Œuvre",
    business_step_implementation_desc: "Obtenez un soutien pour le lancement ou la mise à l'échelle de votre entreprise.",
    business_step_monitoring: "Suivi",
    business_step_monitoring_desc: "Soutien et conseils continus au fur et à mesure que votre entreprise se développe.",
    business_eligibility_title: "Qui Peut Postuler?",
    business_eligibility_1: "Être âgé d'au moins 18 ans avec une idée commerciale viable",
    business_eligibility_2: "Démontrer un engagement envers l'entrepreneuriat et la croissance",
    business_eligibility_3: "Être disposé à travailler avec des mentors et à terminer la formation",
    business_eligibility_4: "Montrer un potentiel de création d'emplois",
    business_cta_title: "Prêt à Commencer Votre Voyage?",
    business_cta_text: "Rejoignez notre Programme de Soutien Commercial et connectez-vous avec des mentors, des investisseurs et d'autres entrepreneurs qui peuvent vous aider à réussir.",

    // Programs page
    programs_title: "Nos Programmes de Soutien",
    programs_subtitle: "Des programmes complets conçus pour vous aider à vous reconstruire et à réussir",
    programs_available: "Programmes Disponibles",
    program_training_title: "Formation Commerciale et Développement des Compétences",
    program_training_short: "Des cours professionnels pour enrichir vos connaissances commerciales",
    program_training_full: "Des cours commerciaux complets couvrant des sujets essentiels tels que la planification commerciale, le marketing numérique, la gestion financière et l'excellence opérationnelle. Notre programme a été conçu par des experts du secteur et adapté à vos besoins.",
    program_training_benefit_1: "Ateliers de formation pratiques",
    program_training_benefit_2: "Certificat après l'achèvement avec succès",
    program_training_benefit_3: "Accès aux matériels d'apprentissage et ressources",
    program_training_benefit_4: "Mise en réseau avec d'autres participants",
    program_training_duration: "3-6 mois",
    program_training_cost: "Gratuit",
    program_mentorship_title: "Programme de Mentorat et Coaching",
    program_mentorship_short: "Conseils individuels de la part d'entrepreneurs expérimentés",
    program_mentorship_full: "Obtenez des conseils personnalisés de la part d'entrepreneurs prospères qui ont déjà parcouru ce chemin. Nos mentors fournissent des conseils stratégiques, aident à surmonter les défis et accélèrent la croissance de votre entreprise.",
    program_mentorship_benefit_1: "Séances de mentorat individuelles",
    program_mentorship_benefit_2: "Stratégie commerciale personnalisée",
    program_mentorship_benefit_3: "Examens réguliers des progrès",
    program_mentorship_benefit_4: "Accès au réseau du mentor",
    program_mentorship_duration: "6-12 mois",
    program_mentorship_cost: "Gratuit",
    program_networking_title: "Événements de Réseautage Commercial",
    program_networking_short: "Rencontrez des entrepreneurs, des partenaires et des investisseurs",
    program_networking_full: "Participez à nos événements communautaires où vous pouvez rencontrer d'autres entrepreneurs, des partenaires potentiels, des investisseurs et des prestataires de services. Construisez des relations précieuses qui peuvent aider votre entreprise à croître.",
    program_networking_benefit_1: "Événements de réseautage mensuels",
    program_networking_benefit_2: "Accès aux opportunités de pitch pour investisseurs",
    program_networking_benefit_3: "Opportunités de partenariat et de collaboration",
    program_networking_benefit_4: "Plateforme communautaire en ligne",
    program_networking_duration: "Continu",
    program_networking_cost: "Gratuit",
    program_grants_title: "Programmes de Subventions et Financement",
    program_grants_short: "Accès aux ressources financières et microcrédits",
    program_grants_full: "Nous accordons des subventions, des microcrédits et vous mettons en relation avec des investisseurs. Nos programmes de financement sont conçus pour soutenir les entreprises à différents stades de développement.",
    program_grants_benefit_1: "Subventions jusqu'à 5 000 EUR",
    program_grants_benefit_2: "Microcrédits à des conditions favorables",
    program_grants_benefit_3: "Services d'appariement d'investissements",
    program_grants_benefit_4: "Aide à la planification financière",
    program_grants_duration: "3-4 mois d'approbation",
    program_grants_cost: "Demande gratuite",
    program_accelerator_title: "Programme d'Accélérateur Commercial",
    program_accelerator_short: "Un programme intensif pour mettre à l'échelle rapidement votre entreprise",
    program_accelerator_full: "Notre programme d'accélérateur de 6 mois combine le mentorat, la formation et le financement pour aider les entreprises prometteuses à se développer. Accédez à des conseillers experts, des ressources et des opportunités d'investissement.",
    program_accelerator_benefit_1: "Programme intensif de 6 mois",
    program_accelerator_benefit_2: "Opportunités de financement jusqu'à 25 000 EUR",
    program_accelerator_benefit_3: "Conseil consultatif d'experts",
    program_accelerator_benefit_4: "Jour de démo et pitch pour investisseurs",
    program_accelerator_duration: "6 mois intensifs",
    program_accelerator_cost: "Capital variable",
    program_about: "À Propos de Ce Programme",
    program_benefits: "Avantages Clés",
    program_duration: "Durée du Programme",
    program_cost: "Coût",
    program_apply: "Demander Maintenant",
    programs_why_choose: "Pourquoi Choisir Nos Programmes",
    programs_feature_1_title: "Programmes Dirigés par des Experts",
    programs_feature_1_desc: "Tous nos programmes sont conçus et dirigés par des experts du secteur ayant des années d'expérience",
    programs_feature_2_title: "Soutien Personnalisé",
    programs_feature_2_desc: "Nous adaptons nos programmes à vos besoins et objectifs spécifiques",
    programs_feature_3_title: "Centré sur la Communauté",
    programs_feature_3_desc: "Faites partie d'une communauté solidaire d'entrepreneurs et d'innovateurs",
    programs_how_apply: "Comment Postuler",
    programs_apply_step_1_title: "Soumettez Votre Candidature",
    programs_apply_step_1_desc: "Remplissez notre formulaire de candidature en ligne avec les détails de votre entreprise et vos objectifs",
    programs_apply_step_2_title: "Évaluation Initiale",
    programs_apply_step_2_desc: "Notre équipe examine votre candidature et effectue une évaluation initiale",
    programs_apply_step_3_title: "Entretien et Approbation",
    programs_apply_step_3_desc: "Les candidats sélectionnés sont invités à un entretien avec notre équipe d'évaluation",
    programs_apply_step_4_title: "Inscription au Programme",
    programs_apply_step_4_desc: "Une fois approuvé, vous recevrez les détails d'inscription et commencerez votre parcours de programme",
    programs_cta_title: "Prêt à Transformer Votre Entreprise?",
    programs_cta_text: "Choisissez le programme qui correspond le mieux à vos besoins et franchissez la première étape vers la création d'une entreprise réussie et durable.",
    programs_cta_button: "Explorer les Programmes",

    // Partners page
    partners_title: "Nos Partenaires",
    partners_subtitle: "Des partenariats stratégiques qui renforcent notre mission et élargissent notre impact",
    partners_our_partners: "Nos Partenaires Stratégiques",
    partners_expertise: "Expertise",
    partners_areas: "Domaines d'Activité",
    partners_role_ecosystem: "Rôle dans l'Écosystème Graweo",

    // U-Cloud24
    partner_ucloud_short: "Partenaire technologique fournissant l'infrastructure cloud, le soutien DevOps et les solutions d'IA",
    partner_ucloud_full: "U-Cloud24 est un partenaire technologique de la Fondation Graweo, fournissant l'infrastructure cloud, le soutien DevOps et les solutions d'IA pour les projets financés par des subventions et des programmes d'entreprise. L'entreprise aide les organisations à créer des environnements numériques sécurisés, évolutifs et conformes aux exigences européennes. U-Cloud24 se spécialise dans les technologies cloud modernes, les déploiements automatisés, les outils d'analyse de données et l'assurance de la conformité aux normes GDPR et ISO.",
    partner_ucloud_role: "Partenaire Technologie et Infrastructure",
    partner_ucloud_expertise_cloud: "Infrastructure cloud et services DevOps",
    partner_ucloud_expertise_ai: "Solutions basées sur l'IA et outils d'automatisation",
    partner_ucloud_expertise_security: "Sécurité des données et capacités d'analyse",
    partner_ucloud_expertise_compliance: "Expertise en conformité GDPR et ISO",
    partner_ucloud_area_cloud: "Infrastructure Cloud",
    partner_ucloud_area_devops: "Services DevOps",
    partner_ucloud_area_ai: "IA et Automatisation",
    partner_ucloud_area_security: "Sécurité des Données et Conformité",
    partner_ucloud_role_1: "Infrastructure pour les projets de recherche et d'innovation",
    partner_ucloud_role_2: "Support DevOps pour les équipes financées par des subventions",
    partner_ucloud_role_3: "Outils d'IA pour l'analyse de données et l'automatisation",
    partner_ucloud_role_4: "Assurance de la sécurité et de la conformité (GDPR, ISO)",

    // Craft-Me
    partner_craftme_short: "Partenaire créatif spécialisé dans la production vidéo, la narration visuelle et la création de contenu pour les initiatives sociales et culturelles",
    partner_craftme_full: "Craft-Me est un partenaire créatif de la Fondation Graweo, spécialisé dans la production vidéo, la narration visuelle et la création de contenu pour les initiatives sociales, éducatives et culturelles. L'équipe Craft-Me aide la fondation à raconter des histoires convaincantes, à attirer l'attention sur les questions importantes et à amplifier l'impact des projets grâce à des contenus vidéo et visuels professionnels.",
    partner_craftme_role: "Partenaire Créatif et Contenu",
    partner_craftme_expertise_video: "Production vidéo professionnelle et narration documentaire",
    partner_craftme_expertise_visual: "Création de contenu visuel et conception pour les plateformes numériques",
    partner_craftme_expertise_campaigns: "Campagnes sur les réseaux sociaux et marketing numérique",
    partner_craftme_expertise_communication: "Soutien des communications européennes et contenu multilingue",
    partner_craftme_area_video: "Production Vidéo",
    partner_craftme_area_content: "Création de Contenu",
    partner_craftme_area_social: "Réseaux Sociaux",
    partner_craftme_area_creative: "Campagnes Créatives",
    partner_craftme_role_1: "Production de vidéos documentaires et sociales",
    partner_craftme_role_2: "Création de matériel visuel pour les demandes de subvention",
    partner_craftme_role_3: "Développement et mise en œuvre de campagnes créatives",
    partner_craftme_role_4: "Soutien des communications de la fondation en Europe",
    // DAOS
    partner_daos_short: "Partenaire santé dédié à soutenir les personnes dans la préservation de leur bien-être physique et mental à travers des programmes accessibles et des soins holistiques",
    partner_daos_full: "DAOS est un partenaire santé de la Fondation Graweo, dédié à aider les personnes à préserver leur santé physique et mentale. DAOS développe et met en œuvre des programmes accessibles axés sur le bien-être holistique, le soutien à la santé mentale et la rééducation physique. En collaboration avec la fondation, DAOS œuvre pour que les personnes touchées par des défis sociaux et humanitaires aient accès à un soutien et des soins de santé de qualité.",
    partner_daos_role: "Partenaire Santé et Bien-être",
    partner_daos_expertise_1: "Programmes de préservation de la santé physique et de rééducation",
    partner_daos_expertise_2: "Soutien à la santé mentale et au bien-être psychologique",
    partner_daos_expertise_3: "Approches holistiques et préventives des soins de santé",
    partner_daos_expertise_4: "Éducation à la santé et sensibilisation de la communauté",
    partner_daos_area_1: "Santé Physique",
    partner_daos_area_2: "Santé Mentale",
    partner_daos_area_3: "Rééducation",
    partner_daos_area_4: "Programmes de Bien-être",
    partner_daos_role_1: "Programmes de préservation de la santé physique pour les bénéficiaires de la fondation",
    partner_daos_role_2: "Soutien à la santé mentale et assistance psychologique",
    partner_daos_role_3: "Initiatives de bien-être holistique et éducation à la santé",
    partner_daos_role_4: "Soutien à la réhabilitation et au rétablissement des communautés affectées",

    partners_visit_website: "Visiter le Site",
    partners_join_title: "Devenez Partenaire",
    partners_join_desc: "Vous êtes intéressé par l'adhésion au réseau de partenaires Graweo? Nous accueillons les organisations qui partagent notre vision de soutien au développement durable et à l'autonomisation des communautés.",
    partners_contact_us: "Nous Contacter",
    partners_benefits_title: "Avantages du Partenariat",
    partnership_benefit_1_title: "Vision Partagée",
    partnership_benefit_1_desc: "Travailler avec une organisation engagée dans l'impact social et le développement durable",
    partnership_benefit_2_title: "Excellence Technique",
    partnership_benefit_2_desc: "Accès à une expertise professionnelle et des ressources dans plusieurs secteurs",
    partnership_benefit_3_title: "Croissance Durable",
    partnership_benefit_3_desc: "Construire des solutions durables avec un impact positif sur l'environnement et la société",
    partnership_benefit_4_title: "Expansion du Réseau",
    partnership_benefit_4_desc: "Connectez-vous avec des organisations partageant vos idées et élargissez votre influence",
    partners_values_title: "Valeurs du Partenariat",
    partners_value_1_title: "Intégrité et Transparence",
    partners_value_1_desc: "Nous opérons avec une transparence complète et maintenons les normes éthiques les plus élevées dans tous les partenariats et opérations.",
    partners_value_2_title: "Durabilité",
    partners_value_2_desc: "Nous priorisons les solutions durables à long terme plutôt que les correctifs rapides, assurant un impact positif durable.",
    partners_value_3_title: "Collaboration",
    partners_value_3_desc: "Nous croyons au pouvoir du partenariat et travaillons étroitement avec nos partenaires pour atteindre des objectifs communs.",
    partners_value_4_title: "Axé sur l'Impact",
    partners_value_4_desc: "Chaque décision est guidée par notre engagement à créer des changements positifs significatifs et mesurables.",
    partners_cta_title: "Prêt à Changer le Monde Ensemble?",
    partners_cta_text: "Rejoignez notre réseau de partenaires stratégiques et aidez-nous à transformer des vies par le développement durable et le soutien communautaire.",
    partners_cta_button: "Explorer le Partenariat",
    learn_more: "En savoir plus",

    // 404 Page
    notfound_title: "Page Non Trouvée",
    notfound_description: "La page que vous recherchez n'existe pas ou a été déplacée. Laissez-nous vous remettre sur la bonne voie!",
    notfound_home: "Aller à l'Accueil",
    notfound_back: "Retour",
    notfound_help: "Besoin d'aide pour trouver quelque chose?",
    notfound_contact: "Contactez-nous",

    footer_tagline: "Soutien à la récupération et à la reconstruction",
    footer_links: "Liens Rapides",
    footer_contact: "Informations de Contact",
    footer_rights: "Tous droits réservés",
    footer_gdpr_link: "Politique de Confidentialité & RGPD",

    gdpr_badge: "Conformité RGPD",
    gdpr_title: "Politique de Confidentialité & RGPD",
    gdpr_subtitle: "Comment nous collectons, utilisons et protégeons vos données personnelles",
    gdpr_updated: "Dernière mise à jour : mars 2026",
    gdpr_intro_title: "Introduction",
    gdpr_intro_text: "La Fondation Caritative Graweo s'engage à protéger vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD) (UE) 2016/679. Cette politique explique quelles données nous collectons, comment nous les utilisons et quels droits vous avez en tant que personne concernée. En utilisant notre site et nos services, vous confirmez avoir lu cette politique et consentez au traitement de vos données personnelles.",
    gdpr_data_title: "Quelles données personnelles nous collectons",
    gdpr_data_text: "Nous pouvons collecter les catégories suivantes de données personnelles : informations de contact (nom, adresse e-mail) lors de la soumission de formulaires ou de dons ; informations de paiement traitées en toute sécurité via des prestataires de paiement certifiés (Stripe) ; données d'utilisation et d'analyse collectées automatiquement lors de la visite (adresse IP, type de navigateur, pages visitées) ; données de communication lors d'un contact par e-mail ou Telegram.",
    gdpr_purpose_title: "Base juridique et finalité du traitement",
    gdpr_purpose_text: "Nous traitons vos données personnelles sur les bases juridiques suivantes :\n\n(1) Consentement — pour les abonnements à la newsletter et les communications marketing.\n\n(2) Nécessité contractuelle — pour traiter les dons et fournir nos services.\n\n(3) Intérêts légitimes — pour améliorer notre site et nos services et prévenir la fraude.\n\n(4) Obligation légale — pour respecter les lois et réglementations applicables.",
    gdpr_rights_title: "Vos droits en vertu du RGPD",
    gdpr_rights_intro: "En tant que personne concernée au titre du RGPD, vous disposez des droits suivants. Pour les exercer, contactez-nous à info@graweo.org.",
    gdpr_right_access: "Droit d'accès",
    gdpr_right_access_desc: "Vous avez le droit de demander une copie de vos données personnelles que nous détenons, ainsi que des informations sur leur utilisation.",
    gdpr_right_deletion: "Droit à l'effacement",
    gdpr_right_deletion_desc: "Vous pouvez demander la suppression de vos données personnelles lorsqu'elles ne sont plus nécessaires aux fins pour lesquelles elles ont été collectées.",
    gdpr_right_portability: "Droit à la portabilité des données",
    gdpr_right_portability_desc: "Vous avez le droit de recevoir vos données dans un format structuré, couramment utilisé et lisible par machine, et de les transférer à un autre responsable.",
    gdpr_right_objection: "Droit d'opposition",
    gdpr_right_objection_desc: "Vous pouvez vous opposer au traitement de vos données à des fins de marketing direct ou pour des raisons tenant à votre situation particulière.",
    gdpr_right_restriction: "Droit à la limitation du traitement",
    gdpr_right_restriction_desc: "Vous avez le droit de demander la limitation du traitement de vos données dans certaines circonstances.",
    gdpr_right_correction: "Droit de rectification",
    gdpr_right_correction_desc: "Vous avez le droit de demander la correction de données inexactes ou incomplètes que nous détenons.",
    gdpr_tech_title: "Infrastructure Technique & Sécurité des Données",
    gdpr_tech_text_before: "Notre site web et notre infrastructure numérique sont hébergés et maintenus par",
    gdpr_tech_text_after: "— notre partenaire technologique spécialisé dans les environnements cloud sécurisés conformes au RGPD. U-Cloud24 fournit l'infrastructure cloud, le support DevOps et les services de sécurité des données, garantissant que toutes les données personnelles sont stockées et traitées conformément aux normes européennes de protection des données. U-Cloud24 agit en tant que sous-traitant au sens du RGPD et respecte les normes de sécurité ISO.",
    gdpr_tech_visit: "En savoir plus sur les capacités techniques de U-Cloud24 sur",
    gdpr_cookies_title: "Cookies et Analyses",
    gdpr_cookies_text: "Notre site utilise des cookies et Google Analytics (via Google Tag Manager) pour comprendre comment les visiteurs interagissent avec notre contenu. Cela inclut les cookies strictement nécessaires au fonctionnement du site et les cookies analytiques nous aidant à améliorer nos services. Les données analytiques sont anonymisées dans la mesure du possible. Vous pouvez désactiver les cookies non essentiels dans les paramètres de votre navigateur.",
    gdpr_consent_title: "Votre Consentement",
    gdpr_consent_text: "En utilisant ce site, en soumettant un formulaire de contact ou en effectuant un don, vous confirmez avoir lu et compris cette Politique de Confidentialité et RGPD et consentez au traitement de vos données personnelles. Vous avez le droit de retirer votre consentement à tout moment en nous contactant.",
    gdpr_contact_title: "Nous Contacter pour les Demandes de Données",
    gdpr_contact_text: "Pour exercer l'un de vos droits RGPD ou pour toute question sur la manière dont nous traitons vos données, contactez notre délégué à la protection des données :",
    gdpr_contact_form_link: "Utiliser le formulaire de contact",
  },

  es: {
    nav_home: "Inicio",
    nav_about: "Acerca de",
    nav_business: "Apoyo Empresarial",
    nav_programs: "Programas",
    nav_partners: "Socios",
    nav_donate: "Donar",
    nav_reports: "Reportes",
    nav_contacts: "Contacto",

    hero_title: "Crear Esperanza a Través del Apoyo",
    hero_subtitle: "Fundación Benéfica Graweo",
    hero_description: "Creamos condiciones para que las personas que han experimentado circunstancias difíciles puedan reconstruir sus vidas, trabajos y dignidad",
    hero_cta: "Donar Ahora",

    about_title: "Acerca de la Fundación",
    about_description: "Graweo es una fundación benéfica dedicada a ayudar a las personas a reconstruirse después de dificultades. Nos enfocamos en proporcionar apoyo para la recuperación, reintegración y restauración de medios de vida.",

    directions_title: "Áreas de Ayuda",
    direction_humanitarian: "Apoyo Esencial",
    direction_humanitarian_desc: "Recursos, asistencia y necesidades para la recuperación",
    direction_idps: "Reintegración",
    direction_idps_desc: "Integración comunitaria, apoyo legal",
    direction_business: "Restauración de Medios de Vida",
    direction_business_desc: "Capacitación en habilidades, apoyo empresarial, asistencia laboral",

    howwework_title: "Cómo Trabajamos",
    howwework_step1: "Entender Necesidades",
    howwework_step1_desc: "Analizamos situaciones y evaluamos circunstancias individuales",
    howwework_step2: "Movilizar Recursos",
    howwework_step2_desc: "Atraemos apoyo y encontramos socios",
    howwework_step3: "Proporcionar Apoyo",
    howwework_step3_desc: "Proporcionamos asistencia personalizada a quienes la necesitan",
    howwework_step4: "Reportar y Aprender",
    howwework_step4_desc: "Transparencia total y mejora continua",

    latest_reports: "Últimos Reportes",
    view_report: "Ver Reporte",
    all_reports: "Todos los Reportes",
    video_title: "Graweo en Acción",

    donate_title: "Apoye Nuestra Misión",
    donate_subtitle: "Su contribución nos ayuda a proporcionar ayuda esencial a los necesitados",

    crypto_title: "Donaciones en Criptomonedas",
    crypto_subtitle: "Instantáneo y seguro",
    copy_address: "Copiar Dirección",
    address_copied: "¡Dirección copiada!",

    bank_title: "Transferencia Bancaria",
    card_coming_soon: "Próximamente — los detalles de transferencia bancaria estarán disponibles en breve.",
    bank_ukraine: "Ucrania (UAH)",
    bank_poland: "Polonia (PLN/EUR)",

    card_title: "Pago con Tarjeta",
    card_button: "Donar por Tarjeta",
    card_description: "Pago rápido y seguro con tarjeta de crédito o débito a través de Stripe",

    currency_select_title: "Elige la moneda de la donación",
    currency_select_subtitle: "Selecciona la moneda en la que deseas donar",
    currency_donate_button: "Donar",
    currency_stripe_note: "Serás redirigido a una página de pago segura de Stripe",

    purpose_title: "Propósito de la Donación",
    purpose_humanitarian: "Apoyo Esencial",
    purpose_idps: "Reintegración",
    purpose_business: "Restauración de Medios de Vida",
    purpose_other: "Otro",

    reports_title: "Nuestros Reportes",
    reports_subtitle: "Transparencia en cada paso",
    date: "Fecha",
    read_more: "Leer Más",

    back_to_reports: "Volver a Reportes",
    gallery_title: "Galería de Fotos",

    contacts_title: "Contáctenos",
    contacts_subtitle: "Estamos aquí para responder tus preguntas",

    contact_email: "Correo",
    contact_telegram: "Telegram",
    contact_form_title: "Enviar Mensaje",

    form_name: "Tu Nombre",
    form_email: "Tu Correo",
    form_message: "Mensaje",
    form_submit: "Enviar Mensaje",
    form_success: "¡Gracias! Tu mensaje ha sido enviado exitosamente.",

    business_hero_subtitle: "Apoyar a los empresarios a reconstruir y desarrollar sus negocios",
    business_apply_now: "Solicitar Ahora",
    business_overview_title: "Construyendo Éxito Juntos",
    business_overview_text: "Nuestro Programa de Apoyo Empresarial proporciona asistencia integral a empresarios que están reconstruyendo sus medios de vida. Ofrecemos capacitación, mentoría, oportunidades de networking y apoyo financiero para ayudarte a lanzar o expandir tu negocio.",
    business_benefit_1: "Capacitación empresarial profesional y desarrollo de habilidades",
    business_benefit_2: "Mentoría uno a uno de empresarios experimentados",
    business_benefit_3: "Acceso a recursos financieros y programas de microcrédito",
    business_programs_title: "Nuestros Programas de Apoyo",
    business_program_training: "Capacitación Empresarial",
    business_program_training_desc: "Cursos integrales que cubren planificación empresarial, marketing, gestión financiera y excelencia operativa.",
    business_program_mentorship: "Mentoría y Coaching",
    business_program_mentorship_desc: "Orientación personalizada de empresarios experimentados para ayudarte a superar desafíos y acelerar el crecimiento.",
    business_program_networking: "Networking Empresarial",
    business_program_networking_desc: "Conecta con otros empresarios, socios potenciales e inversores en nuestra comunidad.",
    business_program_funding: "Apoyo Financiero",
    business_program_funding_desc: "Acceso a subvenciones, microcréditos y oportunidades de inversión para financiar tus empresas.",
    business_process_title: "Nuestro Proceso de 4 Pasos",
    business_step_assessment: "Evaluación",
    business_step_assessment_desc: "Evaluamos tu idea empresarial y situación actual.",
    business_step_planning: "Planificación",
    business_step_planning_desc: "Desarrolla un plan empresarial y financiero integral.",
    business_step_implementation: "Implementación",
    business_step_implementation_desc: "Obtén apoyo al lanzar o escalar tu negocio.",
    business_step_monitoring: "Seguimiento",
    business_step_monitoring_desc: "Apoyo y orientación continuos mientras tu negocio crece.",
    business_eligibility_title: "¿Quién Puede Solicitar?",
    business_eligibility_1: "Tener al menos 18 años con una idea empresarial viable",
    business_eligibility_2: "Demostrar compromiso con el emprendimiento y el crecimiento",
    business_eligibility_3: "Estar dispuesto a trabajar con mentores y completar la capacitación",
    business_eligibility_4: "Mostrar potencial para crear oportunidades de empleo",
    business_cta_title: "¿Listo para Comenzar Tu Viaje?",
    business_cta_text: "Únete a nuestro Programa de Apoyo Empresarial y conecta con mentores, inversores y otros empresarios que pueden ayudarte a tener éxito.",

    // Programs page
    programs_title: "Nuestros Programas de Apoyo",
    programs_subtitle: "Programas integrales diseñados para ayudarte a reconstruirte y tener éxito",
    programs_available: "Programas Disponibles",
    program_training_title: "Capacitación Empresarial y Desarrollo de Habilidades",
    program_training_short: "Cursos profesionales para enriquecer tus conocimientos empresariales",
    program_training_full: "Cursos empresariales integrales que cubren temas esenciales como planificación empresarial, marketing digital, gestión financiera y excelencia operativa. Nuestro programa fue diseñado por expertos de la industria y adaptado a tus necesidades.",
    program_training_benefit_1: "Talleres de capacitación prácticos",
    program_training_benefit_2: "Certificado después de la finalización exitosa",
    program_training_benefit_3: "Acceso a materiales y recursos de aprendizaje",
    program_training_benefit_4: "Redes con otros participantes",
    program_training_duration: "3-6 meses",
    program_training_cost: "Gratis",
    program_mentorship_title: "Programa de Mentoría y Coaching",
    program_mentorship_short: "Orientación individual de empresarios experimentados",
    program_mentorship_full: "Obtén orientación personalizada de empresarios exitosos que ya han recorrido el camino. Nuestros mentores proporcionan asesoramiento estratégico, ayudan a superar desafíos y aceleran el crecimiento de tu negocio.",
    program_mentorship_benefit_1: "Sesiones de mentoría individuales",
    program_mentorship_benefit_2: "Estrategia empresarial personalizada",
    program_mentorship_benefit_3: "Revisiones regulares del progreso",
    program_mentorship_benefit_4: "Acceso a la red del mentor",
    program_mentorship_duration: "6-12 meses",
    program_mentorship_cost: "Gratis",
    program_networking_title: "Eventos de Redes Empresariales",
    program_networking_short: "Conoce a empresarios, socios e inversores",
    program_networking_full: "Únete a nuestros eventos comunitarios donde puedes conocer a otros empresarios, socios potenciales, inversores y proveedores de servicios. Construye relaciones valiosas que pueden ayudar a tu negocio a crecer.",
    program_networking_benefit_1: "Eventos de redes mensuales",
    program_networking_benefit_2: "Acceso a oportunidades de pitch para inversores",
    program_networking_benefit_3: "Oportunidades de alianza y colaboración",
    program_networking_benefit_4: "Plataforma comunitaria en línea",
    program_networking_duration: "Continuo",
    program_networking_cost: "Gratis",
    program_grants_title: "Programas de Subsidios y Financiamiento",
    program_grants_short: "Acceso a recursos financieros y microcréditos",
    program_grants_full: "Proporcionamos subsidios, microcréditos y te conectamos con inversores. Nuestros programas de financiamiento están diseñados para apoyar negocios en diferentes etapas de desarrollo.",
    program_grants_benefit_1: "Subsidios hasta EUR 5,000",
    program_grants_benefit_2: "Microcréditos con términos favorables",
    program_grants_benefit_3: "Servicios de emparejamiento de inversiones",
    program_grants_benefit_4: "Asistencia en planificación financiera",
    program_grants_duration: "3-4 meses de aprobación",
    program_grants_cost: "Solicitud gratuita",
    program_accelerator_title: "Programa Acelerador de Negocios",
    program_accelerator_short: "Programa intensivo para escalar tu negocio rápidamente",
    program_accelerator_full: "Nuestro programa acelerador de 6 meses combina mentoría, capacitación y financiamiento para ayudar a negocios prometedores a crecer. Accede a asesores expertos, recursos y oportunidades de inversión.",
    program_accelerator_benefit_1: "Programa intensivo de 6 meses",
    program_accelerator_benefit_2: "Oportunidades de financiamiento hasta EUR 25,000",
    program_accelerator_benefit_3: "Junta de asesores expertos",
    program_accelerator_benefit_4: "Día de demostración y pitch para inversores",
    program_accelerator_duration: "6 meses intensivos",
    program_accelerator_cost: "Capital variable",
    program_about: "Acerca de Este Programa",
    program_benefits: "Beneficios Clave",
    program_duration: "Duración del Programa",
    program_cost: "Costo",
    program_apply: "Solicita Ahora",
    programs_why_choose: "Por Qué Elegir Nuestros Programas",
    programs_feature_1_title: "Programas Liderados por Expertos",
    programs_feature_1_desc: "Todos nuestros programas son diseñados y liderados por expertos de la industria con años de experiencia",
    programs_feature_2_title: "Apoyo Personalizado",
    programs_feature_2_desc: "Adaptamos nuestros programas a tus necesidades y objetivos específicos",
    programs_feature_3_title: "Enfocado en la Comunidad",
    programs_feature_3_desc: "Sé parte de una comunidad solidaria de empresarios e innovadores",
    programs_how_apply: "Cómo Solicitar",
    programs_apply_step_1_title: "Envía Tu Solicitud",
    programs_apply_step_1_desc: "Completa nuestro formulario de solicitud en línea con detalles sobre tu negocio y objetivos",
    programs_apply_step_2_title: "Evaluación Inicial",
    programs_apply_step_2_desc: "Nuestro equipo revisa tu solicitud y realiza una evaluación inicial",
    programs_apply_step_3_title: "Entrevista y Aprobación",
    programs_apply_step_3_desc: "Los candidatos seleccionados son invitados a una entrevista con nuestro equipo de evaluación",
    programs_apply_step_4_title: "Inscripción en el Programa",
    programs_apply_step_4_desc: "Una vez aprobado, recibirás los detalles de inscripción y comenzarás tu viaje en el programa",
    programs_cta_title: "¿Listo para Transformar Tu Negocio?",
    programs_cta_text: "Elige el programa que mejor se adapte a tus necesidades y da el primer paso hacia la construcción de un negocio exitoso y sostenible.",
    programs_cta_button: "Explorar Programas",

    // Partners page
    partners_title: "Nuestros Socios",
    partners_subtitle: "Asociaciones estratégicas que fortalecen nuestra misión y expanden nuestro impacto",
    partners_our_partners: "Nuestros Socios Estratégicos",
    partners_expertise: "Experiencia",
    partners_areas: "Áreas de Actividad",
    partners_role_ecosystem: "Rol en el Ecosistema Graweo",

    // U-Cloud24
    partner_ucloud_short: "Socio tecnológico que proporciona infraestructura en la nube, soporte DevOps y soluciones de IA",
    partner_ucloud_full: "U-Cloud24 es un socio tecnológico de la Fundación Graweo que proporciona infraestructura en la nube, soporte DevOps y soluciones de IA para proyectos financiados por subvenciones y programas corporativos. La empresa ayuda a las organizaciones a construir entornos digitales seguros, escalables y conformes a los requisitos europeos. U-Cloud24 se especializa en tecnologías en la nube modernas, implementaciones automatizadas, herramientas de análisis de datos y garantía de cumplimiento de estándares GDPR e ISO.",
    partner_ucloud_role: "Socio Tecnológico e Infraestructura",
    partner_ucloud_expertise_cloud: "Infraestructura en la nube y servicios DevOps",
    partner_ucloud_expertise_ai: "Soluciones impulsadas por IA y herramientas de automatización",
    partner_ucloud_expertise_security: "Seguridad de datos y capacidades de análisis",
    partner_ucloud_expertise_compliance: "Experiencia en cumplimiento de GDPR e ISO",
    partner_ucloud_area_cloud: "Infraestructura en la Nube",
    partner_ucloud_area_devops: "Servicios DevOps",
    partner_ucloud_area_ai: "IA y Automatización",
    partner_ucloud_area_security: "Seguridad de Datos y Cumplimiento",
    partner_ucloud_role_1: "Infraestructura para proyectos de investigación e innovación",
    partner_ucloud_role_2: "Soporte DevOps para equipos financiados por subvenciones",
    partner_ucloud_role_3: "Herramientas de IA para análisis de datos y automatización",
    partner_ucloud_role_4: "Garantía de seguridad y cumplimiento (GDPR, ISO)",

    // Craft-Me
    partner_craftme_short: "Socio creativo especializado en producción de vídeo, narración visual y creación de contenido para iniciativas sociales y culturales",
    partner_craftme_full: "Craft-Me es un socio creativo de la Fundación Graweo, especializado en producción de vídeo, narración visual y creación de contenido para iniciativas sociales, educativas y culturales. El equipo de Craft-Me ayuda a la fundación a contar historias convincentes, atraer atención sobre temas importantes y amplificar el impacto de los proyectos a través de contenido de vídeo y materiales visuales profesionales.",
    partner_craftme_role: "Socio Creativo y de Contenido",
    partner_craftme_expertise_video: "Producción profesional de vídeo y narración documental",
    partner_craftme_expertise_visual: "Creación de contenido visual y diseño para plataformas digitales",
    partner_craftme_expertise_campaigns: "Campañas en redes sociales y marketing digital",
    partner_craftme_expertise_communication: "Apoyo a comunicaciones europeas y contenido multilingüe",
    partner_craftme_area_video: "Producción de Vídeo",
    partner_craftme_area_content: "Creación de Contenido",
    partner_craftme_area_social: "Redes Sociales",
    partner_craftme_area_creative: "Campañas Creativas",
    partner_craftme_role_1: "Producción de vídeos documentales y sociales",
    partner_craftme_role_2: "Creación de materiales visuales para solicitudes de subvención",
    partner_craftme_role_3: "Desarrollo y ejecución de campañas creativas",
    partner_craftme_role_4: "Apoyo a las comunicaciones de la fundación en Europa",
    // DAOS
    partner_daos_short: "Socio de salud dedicado a apoyar a las personas en la preservación de su bienestar físico y mental a través de programas accesibles y atención holística",
    partner_daos_full: "DAOS es un socio de salud de la Fundación Graweo, dedicado a ayudar a las personas a preservar su salud física y mental. DAOS desarrolla e implementa programas accesibles centrados en el bienestar integral, el apoyo a la salud mental y la rehabilitación física. Junto con la fundación, DAOS trabaja para garantizar que las personas afectadas por desafíos sociales y humanitarios tengan acceso a apoyo y atención sanitaria de calidad.",
    partner_daos_role: "Socio de Salud y Bienestar",
    partner_daos_expertise_1: "Programas de preservación de la salud física y rehabilitación",
    partner_daos_expertise_2: "Apoyo a la salud mental y el bienestar psicológico",
    partner_daos_expertise_3: "Enfoques holísticos y preventivos de la atención sanitaria",
    partner_daos_expertise_4: "Educación sanitaria y programas de concienciación comunitaria",
    partner_daos_area_1: "Salud Física",
    partner_daos_area_2: "Salud Mental",
    partner_daos_area_3: "Rehabilitación",
    partner_daos_area_4: "Programas de Bienestar",
    partner_daos_role_1: "Programas de preservación de la salud física para los beneficiarios de la fundación",
    partner_daos_role_2: "Apoyo a la salud mental y asistencia psicológica",
    partner_daos_role_3: "Iniciativas de bienestar integral y educación sanitaria",
    partner_daos_role_4: "Apoyo a la rehabilitación y recuperación de las comunidades afectadas",

    partners_visit_website: "Visitar Sitio Web",
    partners_join_title: "Conviértete en Socio",
    partners_join_desc: "¿Te interesa unirte a la red de socios de Graweo? Bienvenemos a las organizaciones que comparten nuestra visión de apoyo al desarrollo sostenible y empoderamiento comunitario.",
    partners_contact_us: "Contáctanos",
    partners_benefits_title: "Beneficios de la Asociación",
    partnership_benefit_1_title: "Visión Compartida",
    partnership_benefit_1_desc: "Trabajar con una organización comprometida con el impacto social y el desarrollo sostenible",
    partnership_benefit_2_title: "Excelencia Técnica",
    partnership_benefit_2_desc: "Acceso a experiencia profesional y recursos en múltiples sectores",
    partnership_benefit_3_title: "Crecimiento Sostenible",
    partnership_benefit_3_desc: "Construir soluciones duraderas con impacto positivo en el medio ambiente y la sociedad",
    partnership_benefit_4_title: "Expansión de Red",
    partnership_benefit_4_desc: "Conecta con organizaciones afines y expande tu influencia",
    partners_values_title: "Valores de la Asociación",
    partners_value_1_title: "Integridad y Transparencia",
    partners_value_1_desc: "Operamos con total transparencia y mantenemos los más altos estándares éticos en todas las asociaciones y operaciones.",
    partners_value_2_title: "Sostenibilidad",
    partners_value_2_desc: "Priorizamos soluciones sostenibles a largo plazo sobre correcciones rápidas, asegurando un impacto positivo duradero.",
    partners_value_3_title: "Colaboración",
    partners_value_3_desc: "Creemos en el poder de la asociación y trabajamos estrechamente con nuestros socios para lograr objetivos comunes.",
    partners_value_4_title: "Orientado al Impacto",
    partners_value_4_desc: "Cada decisión está guiada por nuestro compromiso de crear cambios positivos significativos y medibles.",
    partners_cta_title: "¿Listo para Cambiar el Mundo Juntos?",
    partners_cta_text: "Únete a nuestra red de socios estratégicos y ayúdanos a transformar vidas a través del desarrollo sostenible y el apoyo comunitario.",
    partners_cta_button: "Explorar Asociación",
    learn_more: "Saber más",

    // 404 Page
    notfound_title: "Página No Encontrada",
    notfound_description: "La página que buscas no existe o ha sido movida. ¡Déjanos ayudarte a volver al camino correcto!",
    notfound_home: "Ir al Inicio",
    notfound_back: "Volver",
    notfound_help: "¿Necesitas ayuda para encontrar algo?",
    notfound_contact: "Contáctanos",

    footer_tagline: "Apoyo a la recuperación y reconstrucción",
    footer_links: "Enlaces Rápidos",
    footer_contact: "Información de Contacto",
    footer_rights: "Todos los derechos reservados",
    footer_gdpr_link: "Política de Privacidad y RGPD",

    gdpr_badge: "Cumplimiento RGPD",
    gdpr_title: "Política de Privacidad y RGPD",
    gdpr_subtitle: "Cómo recopilamos, usamos y protegemos sus datos personales",
    gdpr_updated: "Última actualización: marzo 2026",
    gdpr_intro_title: "Introducción",
    gdpr_intro_text: "La Fundación Caritativa Graweo se compromete a proteger sus datos personales de conformidad con el Reglamento General de Protección de Datos (RGPD) (UE) 2016/679. Esta política explica qué datos recopilamos, cómo los usamos y qué derechos tiene como interesado. Al utilizar nuestro sitio web y servicios, confirma haber leído esta política y consiente el tratamiento de sus datos personales.",
    gdpr_data_title: "Qué datos personales recopilamos",
    gdpr_data_text: "Podemos recopilar las siguientes categorías de datos personales: información de contacto (nombre, dirección de correo electrónico) al enviar formularios o realizar donaciones; información de pago procesada de forma segura a través de proveedores de pago certificados (Stripe); datos de uso y análisis recopilados automáticamente al visitar nuestro sitio (dirección IP, tipo de navegador, páginas visitadas); datos de comunicación al contactarnos por correo electrónico o Telegram.",
    gdpr_purpose_title: "Base jurídica y finalidad del tratamiento",
    gdpr_purpose_text: "Tratamos sus datos personales sobre las siguientes bases jurídicas:\n\n(1) Consentimiento — para suscripciones a boletines y comunicaciones de marketing.\n\n(2) Necesidad contractual — para procesar donaciones y proporcionar servicios.\n\n(3) Intereses legítimos — para mejorar nuestro sitio y servicios y prevenir el fraude.\n\n(4) Obligación legal — para cumplir con las leyes y regulaciones aplicables.",
    gdpr_rights_title: "Sus derechos según el RGPD",
    gdpr_rights_intro: "Como interesado según el RGPD, tiene los siguientes derechos. Para ejercerlos, contáctenos en info@graweo.org.",
    gdpr_right_access: "Derecho de acceso",
    gdpr_right_access_desc: "Tiene derecho a solicitar una copia de sus datos personales que conservamos, junto con información sobre cómo se utilizan.",
    gdpr_right_deletion: "Derecho de supresión",
    gdpr_right_deletion_desc: "Puede solicitar la eliminación de sus datos personales cuando ya no sean necesarios para los fines para los que fueron recopilados.",
    gdpr_right_portability: "Derecho a la portabilidad de datos",
    gdpr_right_portability_desc: "Tiene derecho a recibir sus datos en un formato estructurado, de uso común y legible por máquina, y a transmitirlos a otro responsable.",
    gdpr_right_objection: "Derecho de oposición",
    gdpr_right_objection_desc: "Puede oponerse al tratamiento de sus datos para fines de marketing directo o por razones relacionadas con su situación particular.",
    gdpr_right_restriction: "Derecho a la limitación del tratamiento",
    gdpr_right_restriction_desc: "Tiene derecho a solicitar la limitación del tratamiento de sus datos personales en determinadas circunstancias.",
    gdpr_right_correction: "Derecho de rectificación",
    gdpr_right_correction_desc: "Tiene derecho a solicitar la corrección de datos inexactos o incompletos que conservamos sobre usted.",
    gdpr_tech_title: "Infraestructura Técnica y Seguridad de Datos",
    gdpr_tech_text_before: "Nuestro sitio web e infraestructura digital están alojados y mantenidos por",
    gdpr_tech_text_after: "— nuestro socio tecnológico especializado en entornos cloud seguros y conformes con el RGPD. U-Cloud24 proporciona infraestructura cloud, soporte DevOps y servicios de seguridad de datos, garantizando que todos los datos personales se almacenen y procesen de acuerdo con los estándares europeos de protección de datos. U-Cloud24 actúa como encargado del tratamiento según el RGPD y cumple con los estándares de seguridad ISO.",
    gdpr_tech_visit: "Más información sobre las capacidades técnicas de U-Cloud24 en",
    gdpr_cookies_title: "Cookies y Análisis",
    gdpr_cookies_text: "Nuestro sitio utiliza cookies y Google Analytics (a través de Google Tag Manager) para comprender cómo los visitantes interactúan con nuestro contenido. Esto incluye cookies estrictamente necesarias para el funcionamiento del sitio y cookies analíticas que nos ayudan a mejorar nuestros servicios. Los datos analíticos se anonimizan en la medida de lo posible. Puede desactivar las cookies no esenciales en la configuración de su navegador.",
    gdpr_consent_title: "Su Consentimiento",
    gdpr_consent_text: "Al utilizar este sitio web, enviar un formulario de contacto o realizar una donación, confirma haber leído y comprendido esta Política de Privacidad y RGPD y consiente el tratamiento de sus datos personales. Tiene derecho a retirar su consentimiento en cualquier momento contactándonos.",
    gdpr_contact_title: "Contáctenos para Solicitudes de Datos",
    gdpr_contact_text: "Para ejercer cualquiera de sus derechos RGPD o si tiene preguntas sobre cómo procesamos sus datos personales, contáctese con nuestro Delegado de Protección de Datos:",
    gdpr_contact_form_link: "Usar el formulario de contacto",
  },
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('graweo_lang');
    return saved && translations[saved] ? saved : 'en';
  });

  const t = (key) => {
    return translations[language][key] || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem('graweo_lang', lang);
    }
  };

  useEffect(() => {
    localStorage.setItem('graweo_lang', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};